(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-collections-cta"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const track = document.getElementById("carousel-track");
    const prevBtn = document.getElementById("carousel-prev");
    const nextBtn = document.getElementById("carousel-next");
    const cards = track.querySelectorAll(".about-collections-cta__card");
    let currentIndex = 0;
    const totalCards = cards.length;
    function getVisibleCards() {
        return window.innerWidth > 968 ? 4 : 1;
    }
    function getCardWidth() {
        return cards[0].offsetWidth;
    }
    function getGap() {
        return window.innerWidth > 968 ? 30 : 20;
    }
    function getMaxIndex() {
        const visibleCards = getVisibleCards();
        return Math.max(0, totalCards - visibleCards);
    }
    function updateCarousel(animate = true) {
        const cardWidth = getCardWidth();
        const gap = getGap();
        const offset = -(currentIndex * (cardWidth + gap));
        if (typeof gsap !== "undefined" && animate) {
            gsap.to(track, {
                x: offset,
                duration: .5,
                ease: "power2.inOut"
            });
        } else {
            track.style.transform = `translateX(${offset}px)`;
        }
        updateArrows();
    }
    function updateArrows() {
        const maxIndex = getMaxIndex();
        if (currentIndex <= 0) {
            prevBtn.disabled = true;
        } else {
            prevBtn.disabled = false;
        }
        if (currentIndex >= maxIndex) {
            nextBtn.disabled = true;
        } else {
            nextBtn.disabled = false;
        }
    }
    prevBtn.addEventListener("click", function() {
        if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
        }
    });
    nextBtn.addEventListener("click", function() {
        const maxIndex = getMaxIndex();
        if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
        }
    });
    let resizeTimer;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            const maxIndex = getMaxIndex();
            if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
            }
            updateCarousel(false);
        }, 250);
    });
    updateArrows();
    const images = track.querySelectorAll(".about-collections-cta__card-image");
    let loadedImages = 0;
    images.forEach(function(img) {
        if (img.complete) {
            loadedImages++;
        } else {
            img.addEventListener("load", function() {
                loadedImages++;
                if (loadedImages === images.length) {
                    updateCarousel(false);
                }
            });
        }
    });
    if (loadedImages === images.length) {
        updateCarousel(false);
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-values"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const cardButtons = document.querySelectorAll(".about-values__card-button");
    const detailImage = document.getElementById("values-detail-image");
    const detailTitle = document.getElementById("values-detail-title");
    const detailText = document.getElementById("values-detail-text");
    cardButtons.forEach(function(button) {
        button.addEventListener("click", function() {
            cardButtons.forEach(function(btn) {
                btn.classList.remove("active");
            });
            this.classList.add("active");
            const valueData = {
                index: this.dataset.valueIndex || "0",
                title: this.dataset.valueTitle || "",
                text: this.dataset.valueText || "",
                image: this.dataset.valueImage || null
            };
            if (typeof gsap !== "undefined") {
                gsap.to([ detailImage, detailTitle, detailText ], {
                    opacity: 0,
                    duration: .2,
                    onComplete: function() {
                        updateDetailPanel(valueData);
                        gsap.to([ detailImage, detailTitle, detailText ], {
                            opacity: 1,
                            duration: .3
                        });
                    }
                });
            } else {
                updateDetailPanel(valueData);
            }
        });
    });
    function updateDetailPanel(data) {
        detailTitle.textContent = data.title;
        detailText.textContent = data.text;
        const currentElement = document.getElementById("values-detail-image");
        if (data.image) {
            if (currentElement.tagName === "IMG") {
                currentElement.src = data.image;
                currentElement.alt = data.title;
                currentElement.dataset.valueIndex = data.index;
            } else {
                const img = document.createElement("img");
                img.src = data.image;
                img.alt = data.title;
                img.className = "about-values__detail-image";
                img.id = "values-detail-image";
                img.dataset.valueIndex = data.index;
                img.width = 600;
                img.height = 338;
                img.loading = "lazy";
                currentElement.parentNode.replaceChild(img, currentElement);
            }
        } else {
            if (currentElement.tagName === "IMG") {
                const placeholder = document.createElement("div");
                placeholder.className = "about-values__detail-image about-values__detail-image--placeholder";
                placeholder.id = "values-detail-image";
                currentElement.parentNode.replaceChild(placeholder, currentElement);
            }
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-why-choose"] && !Shopify.designMode) return;
  try {
    const gsapScript = document.createElement("script");

gsapScript.src = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js";

gsapScript.async = true;

const scrollTriggerScript = document.createElement("script");

scrollTriggerScript.src = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js";

scrollTriggerScript.async = true;

gsapScript.onload = () => {
    scrollTriggerScript.onload = () => {
        initWhyChooseCounters();
    };
    document.head.appendChild(scrollTriggerScript);
};

document.head.appendChild(gsapScript);

function initWhyChooseCounters() {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
        console.log("Why Choose counter animations disabled: prefers-reduced-motion");
        return;
    }
    gsap.registerPlugin(ScrollTrigger);
    const section = document.querySelector(".about-why-choose");
    if (!section) return;
    const title = section.querySelector(".about-why-choose__title");
    const stats = section.querySelectorAll(".about-why-choose__stat");
    const statNumbers = section.querySelectorAll(".about-why-choose__stat-number");
    const statData = Array.from(statNumbers).map(el => ({
        element: el,
        originalText: el.textContent.trim(),
        targetValue: parseStatValue(el.textContent.trim()),
        type: detectStatType(el.textContent.trim())
    }));
    gsap.set([ title, stats ], {
        opacity: 0,
        y: 20
    });
    statData.forEach(stat => {
        if (stat.type !== "text") {
            stat.element.textContent = formatStatValue(0, stat.type);
            stat.element.style.willChange = "contents";
        }
    });
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
            toggleActions: "play none none none"
        }
    });
    tl.to(title, {
        opacity: 1,
        y: 0,
        duration: .6,
        ease: "power2.out"
    });
    tl.to(stats, {
        opacity: 1,
        y: 0,
        duration: .5,
        ease: "power2.out"
    }, "-=0.3");
    statData.forEach((stat, index) => {
        if (stat.type === "text") {
            return;
        }
        const counterTween = gsap.to({
            value: 0
        }, {
            value: stat.targetValue,
            duration: 1.5,
            ease: "power2.out",
            onUpdate: function() {
                const currentValue = this.targets()[0].value;
                stat.element.textContent = formatStatValue(currentValue, stat.type);
            },
            onComplete: function() {
                stat.element.textContent = stat.originalText;
                stat.element.style.willChange = "auto";
            }
        });
        tl.add(counterTween, "-=0.5");
    });
    stats.forEach(stat => {
        stat.addEventListener("mouseenter", () => {
            gsap.to(stat, {
                scale: 1.02,
                duration: .3,
                ease: "power2.out"
            });
        });
        stat.addEventListener("mouseleave", () => {
            gsap.to(stat, {
                scale: 1,
                duration: .3,
                ease: "power2.out"
            });
        });
    });
    console.log("Why Choose counter animations initialized:", {
        title: !!title,
        statsCount: stats.length,
        counters: statData.map(s => ({
            type: s.type,
            target: s.targetValue,
            original: s.originalText
        }))
    });
}

function parseStatValue(text) {
    if (text.includes("M+")) {
        return 1e6;
    }
    if (text.includes("%")) {
        return parseInt(text.replace("%", ""), 10);
    }
    const numMatch = text.match(/\d+/);
    if (numMatch) {
        return parseInt(numMatch[0], 10);
    }
    return null;
}

function detectStatType(text) {
    if (text.includes("M+")) return "millions";
    if (text.includes("%")) return "percentage";
    if (/^\d+$/.test(text)) return "number";
    return "text";
}

function formatStatValue(value, type) {
    switch (type) {
      case "millions":
        if (value >= 1e6) {
            return "1M+";
        } else if (value >= 1e5) {
            return Math.floor(value / 1e3) + "K";
        } else {
            return Math.floor(value / 1e3) + "K";
        }

      case "percentage":
        return Math.floor(value) + "%";

      case "number":
        return Math.floor(value).toString();

      case "text":
        return value;

      default:
        return Math.floor(value).toString();
    }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const thumbnails = document.querySelectorAll(".accessories-pdp-main__thumbnail");
    const mainImage = document.getElementById("mainProductImage");
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl && typeof gsap !== "undefined") {
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: .2,
                        onComplete: () => {
                            mainImage.src = newImageUrl;
                            gsap.to(mainImage, {
                                opacity: 1,
                                duration: .3
                            });
                        }
                    });
                } else if (newImageUrl) {
                    mainImage.src = newImageUrl;
                }
            });
        });
    }
    const quantityInput = document.getElementById("Quantity");
    const decreaseBtn = document.querySelector('[data-action="decrease"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');
    if (quantityInput && decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
        increaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
        });
    }
    const variantInputs = document.querySelectorAll(".accessories-pdp-main__option-input");
    const variantDataElement = document.getElementById("productVariantData");
    const variantIdInput = document.getElementById("productVariantId");
    const priceElement = document.getElementById("priceValue");
    const stockStatusElement = document.getElementById("stockStatus");
    const mainImageEl = document.getElementById("mainProductImage");
    const addToCartBtn = document.getElementById("addToCartBtn");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("Failed to parse variant data:", e);
        }
    }
    function findVariantByOptions(selectedOptions) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(variant => selectedOptions.every((option, index) => variant.options[index] === option));
    }
    function getSelectedOptions() {
        const options = [];
        const optionGroups = document.querySelectorAll(".accessories-pdp-main__option");
        optionGroups.forEach(group => {
            const checkedInput = group.querySelector(".accessories-pdp-main__option-input:checked");
            if (checkedInput) {
                options.push(checkedInput.value);
            }
        });
        return options;
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateMainImage(imageUrl) {
        if (!mainImageEl || !imageUrl) return;
        if (mainImageEl.src === imageUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(mainImageEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    mainImageEl.src = imageUrl;
                    mainImageEl.onload = () => {
                        gsap.to(mainImageEl, {
                            opacity: 1,
                            duration: .3
                        });
                    };
                }
            });
        } else {
            mainImageEl.src = imageUrl;
        }
    }
    function updateThumbnailSelection(imageUrl) {
        if (!imageUrl) return;
        const thumbnails = document.querySelectorAll(".accessories-pdp-main__thumbnail");
        if (!thumbnails.length) return;
        let matchFound = false;
        thumbnails.forEach(thumbnail => {
            const thumbUrl = thumbnail.getAttribute("data-image-url");
            if (thumbUrl === imageUrl) {
                thumbnails.forEach(t => t.classList.remove("active"));
                thumbnail.classList.add("active");
                matchFound = true;
            }
        });
        if (!matchFound) {
            const imageFilename = imageUrl.split("/").pop().split("?")[0];
            thumbnails.forEach(thumbnail => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0] : "";
                if (thumbFilename && thumbFilename === imageFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                }
            });
        }
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) {
            variantIdInput.value = variant.id;
        }
        const installmentsBanner = document.querySelector("shopify-payment-terms");
        if (installmentsBanner && variant.id) {
            installmentsBanner.setAttribute("variant-id", variant.id);
        }
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".accessories-pdp-main__price");
            const compareAtElement = priceContainer?.querySelector(".accessories-pdp-main__price-compare");
            const saleBadge = priceContainer?.querySelector(".accessories-pdp-main__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareAtElement) {
                    compareAtElement.textContent = formatMoney(variant.compareAtPrice);
                    compareAtElement.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("accessories-pdp-main__price-sale");
                priceElement.classList.remove("accessories-pdp-main__price-regular");
            } else {
                if (compareAtElement) compareAtElement.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("accessories-pdp-main__price-sale");
                priceElement.classList.add("accessories-pdp-main__price-regular");
            }
        }
        if (stockStatusElement) {
            if (variant.available) {
                stockStatusElement.innerHTML = '<span class="accessories-pdp-main__stock-in">In Stock</span>';
            } else {
                stockStatusElement.innerHTML = '<span class="accessories-pdp-main__stock-out">Out of Stock</span>';
            }
        }
        if (addToCartBtn) {
            if (variant.available) {
                addToCartBtn.disabled = false;
                addToCartBtn.textContent = "Add to Cart";
            } else {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = "Sold Out";
            }
        }
        if (variant.image) {
            updateMainImage(variant.image);
            updateThumbnailSelection(variant.image);
        } else if (variantData && variantData.featuredImage) {
            updateMainImage(variantData.featuredImage);
            updateThumbnailSelection(variantData.featuredImage);
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", newUrl.toString());
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
        console.log("[Accessories PDP] Variant updated:", variant.title, "ID:", variant.id);
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (variantId) {
            const variant = variantData.variants.find(v => v.id === parseInt(variantId));
            if (variant) {
                variant.options.forEach((optionValue, index) => {
                    const input = document.querySelector(`.accessories-pdp-main__option-input[name="options[${variantData.options[index]}]"][value="${optionValue}"]`);
                    if (input) {
                        input.checked = true;
                    }
                });
                updateVariantUI(variant);
            }
        }
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const selectedOptions = getSelectedOptions();
                const variant = findVariantByOptions(selectedOptions);
                const optionGroup = input.closest(".accessories-pdp-main__option");
                const selectedColorLabel = optionGroup && optionGroup.querySelector(".accessories-pdp-main__selected-color");
                if (selectedColorLabel) {
                    selectedColorLabel.textContent = input.value;
                }
                if (variant) {
                    updateVariantUI(variant);
                } else {
                    console.warn("[Accessories PDP] No matching variant found for options:", selectedOptions);
                }
            });
        });
        initVariantFromURL();
    }
    const productForm = document.getElementById("productForm");
    if (productForm) {
        productForm.addEventListener("submit", async e => {
            e.preventDefault();
            const formData = new FormData(productForm);
            const variantId = formData.get("id");
            const quantity = parseInt(formData.get("quantity")) || 1;
            const submitButton = document.getElementById("addToCartBtn");
            if (submitButton) {
                submitButton.disabled = true;
                const originalText = submitButton.textContent;
                submitButton.textContent = "Adding...";
                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json"
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: quantity,
                            sections: "cart-drawer-items,cart-header-dropdown"
                        })
                    });
                    if (!response.ok) {
                        throw new Error("Failed to add item to cart");
                    }
                    const data = await response.json();
                    console.log("[Accessories PDP] Item added to cart:", data);
                    if (window.cartDrawer && data.sections) {
                        window.cartDrawer.updateCartSections(data.sections);
                    }
                    document.dispatchEvent(new CustomEvent("cart:item:added", {
                        detail: {
                            item: data.items ? data.items[0] : data,
                            sections: data.sections
                        }
                    }));
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                } catch (error) {
                    console.error("[Accessories PDP] Error adding to cart:", error);
                    alert("Sorry, there was an error adding this item to your cart. Please try again.");
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            }
        });
    }
    const enlargeBtn = document.getElementById("enlargeImageBtn");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImage = document.getElementById("zoomImage");
    const zoomOverlay = document.querySelector(".accessories-pdp-main__zoom-overlay");
    const zoomCloseBtn = document.querySelector(".accessories-pdp-main__zoom-close");
    if (enlargeBtn && zoomModal && zoomImage && mainImage) {
        const openModal = () => {
            const currentImageSrc = mainImage.src;
            zoomImage.src = currentImageSrc;
            if (typeof gsap !== "undefined") {
                gsap.set(zoomModal, {
                    display: "flex"
                });
                gsap.fromTo(zoomModal, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                });
            } else {
                zoomModal.style.display = "flex";
                zoomModal.style.opacity = "1";
            }
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            if (typeof gsap !== "undefined") {
                gsap.to(zoomModal, {
                    opacity: 0,
                    duration: .3,
                    ease: "power2.in",
                    onComplete: () => {
                        gsap.set(zoomModal, {
                            display: "none"
                        });
                        zoomImage.src = "";
                    }
                });
            } else {
                zoomModal.style.display = "none";
                zoomImage.src = "";
            }
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        if (zoomCloseBtn) {
            zoomCloseBtn.addEventListener("click", closeModal);
        }
        if (zoomOverlay) {
            zoomOverlay.addEventListener("click", closeModal);
        }
        document.addEventListener("keydown", e => {
            if (e.key === "Escape" && zoomModal.style.display === "flex") {
                closeModal();
            }
        });
    }
    const redrillContainer = document.getElementById("redrillDropdownContainer");
    const redrillTrigger = document.getElementById("redrillDropdownTrigger");
    const redrillMenu = document.getElementById("redrillDropdownMenu");
    if (redrillContainer && redrillTrigger && redrillMenu) {
        const openRedrill = () => {
            redrillContainer.classList.add("open");
            redrillTrigger.setAttribute("aria-expanded", "true");
            redrillMenu.setAttribute("aria-hidden", "false");
        };
        const closeRedrill = () => {
            redrillContainer.classList.remove("open");
            redrillTrigger.setAttribute("aria-expanded", "false");
            redrillMenu.setAttribute("aria-hidden", "true");
        };
        redrillTrigger.addEventListener("click", e => {
            e.preventDefault();
            if (redrillContainer.classList.contains("open")) {
                closeRedrill();
            } else {
                openRedrill();
            }
        });
        document.addEventListener("click", e => {
            if (!redrillContainer.contains(e.target)) closeRedrill();
        });
        document.addEventListener("keydown", e => {
            if (e.key === "Escape") closeRedrill();
        });
        redrillMenu.querySelectorAll(".accessories-pdp-main__dropdown-option").forEach(option => {
            option.addEventListener("click", () => {
                const choice = option.dataset.addOption;
                closeRedrill();
                handleRedrillOption(choice);
            });
        });
        async function handleRedrillOption(choice) {
            const variantId = (document.getElementById("productVariantId") || {}).value || "";
            const handle = redrillContainer.dataset.productHandle || "";
            const redrillPrice = redrillContainer.dataset.productPrice || "";
            if (choice === "redrill-clip") {
                window.location.href = "/pages/order-flow?start=step3&mode=redrill" + "&redrillVariant=" + encodeURIComponent(variantId) + "&redrillHandle=" + encodeURIComponent(handle) + "&redrillPrice=" + encodeURIComponent(redrillPrice) + "&source=redrill-pdp";
                return;
            }
            const quantity = parseInt((document.getElementById("Quantity") || {}).value, 10) || 1;
            const triggerSpan = redrillTrigger.querySelector("span");
            const originalText = triggerSpan ? triggerSpan.textContent : "";
            redrillTrigger.disabled = true;
            if (triggerSpan) triggerSpan.textContent = "Adding...";
            const redrillProps = {
                "_Order Source": "Redrill - Replacement Magnets"
            };
            const selectedFinish = document.querySelector(".accessories-pdp-main__color-swatches .accessories-pdp-main__option-input:checked");
            if (selectedFinish && selectedFinish.value) {
                redrillProps["_Magnet Finish"] = selectedFinish.value;
            }
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity,
                        properties: redrillProps,
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) throw new Error("Failed to add item to cart");
                const data = await response.json();
                if (window.cartDrawer && data.sections) {
                    window.cartDrawer.updateCartSections(data.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: data.items ? data.items[0] : data,
                        sections: data.sections
                    }
                }));
                if (window.cartDrawer && typeof window.cartDrawer.openDrawer === "function") {
                    window.cartDrawer.openDrawer();
                }
            } catch (error) {
                console.error("[Redrill PDP] Error adding to cart:", error);
                alert("Sorry, there was an error adding this item to your cart. Please try again.");
            } finally {
                redrillTrigger.disabled = false;
                if (triggerSpan) triggerSpan.textContent = originalText;
            }
        }
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-product-grid"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const sortSelect = document.getElementById("AccessoriesSortBy");
    if (sortSelect) {
        sortSelect.addEventListener("change", function() {
            const sortValue = this.value;
            const url = new URL(window.location.href);
            url.searchParams.set("sort_by", sortValue);
            window.location.href = url.toString();
        });
        const urlParams = new URLSearchParams(window.location.search);
        const currentSort = urlParams.get("sort_by");
        if (currentSort) {
            sortSelect.value = currentSort;
        }
    }
    console.log("[Accessories PLP] Initialized");
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
class AnnouncementBar {
  constructor(container) {
    this.container = container;
    this.barContainer = container.querySelector('.announcement-bar__container');
    this.messagesContainer = container.querySelector('.announcement-bar__messages');
    this.messages = container.querySelectorAll('.announcement-bar__message');
    this.indicators = container.querySelectorAll('.announcement-bar__indicator');
    this.prevButtons = container.querySelectorAll('.announcement-bar__arrow--prev');
    this.nextButtons = container.querySelectorAll('.announcement-bar__arrow--next');

    this.currentIndex = 0;
    this.isPlaying = this.messagesContainer.dataset.autoplay === 'true';
    this.speed = parseInt(this.messagesContainer.dataset.speed) || 5000;
    this.pauseOnHover = this.messagesContainer.dataset.pauseOnHover === 'true';
    this.intervalId = null;
    this.isPaused = false;

    this.init();
  }

  init() {
    // Check for text overflow on mobile
    this.checkOverflow();
    window.addEventListener('resize', () => this.checkOverflow());

    if (this.messages.length <= 1) return;

    this.bindEvents();

    if (this.isPlaying) {
      this.startAutoplay();
    }
  }

  checkOverflow() {
    // Check each text element for overflow
    const textElements = this.container.querySelectorAll('.announcement-bar__text');
    textElements.forEach(text => {
      const parent = text.closest('.announcement-bar__content');
      if (parent) {
        // Check if text is wider than container
        const isOverflowing = text.scrollWidth > parent.clientWidth;
        if (isOverflowing) {
          text.classList.add('overflow');
        } else {
          text.classList.remove('overflow');
        }
      }
    });
  }

  bindEvents() {
    // Navigation arrows - bind to all instances
    this.prevButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent link navigation if message is wrapped in <a>
        this.goToPrevious();
      });
    });

    this.nextButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent link navigation if message is wrapped in <a>
        this.goToNext();
      });
    });

    // Indicator dots
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => this.goToSlide(index));
    });

    // Pause on hover
    if (this.pauseOnHover) {
      this.container.addEventListener('mouseenter', () => this.pause());
      this.container.addEventListener('mouseleave', () => this.resume());
    }

    // Keyboard navigation
    this.container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.goToPrevious();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.goToNext();
      }
    });

    // Theme editor events
    document.addEventListener('shopify:block:select', (e) => {
      if (this.container.contains(e.target)) {
        const blockIndex = Array.from(this.messages).findIndex(
          msg => msg.dataset.blockId === e.target.dataset.blockId
        );
        if (blockIndex !== -1) {
          this.pause();
          this.goToSlide(blockIndex);
        }
      }
    });

    document.addEventListener('shopify:block:deselect', () => {
      if (this.isPlaying && !this.isPaused) {
        this.resume();
      }
    });
  }

  goToSlide(index) {
    if (index === this.currentIndex) return;

    // Remove active class from current slide
    this.messages[this.currentIndex].classList.remove('active');
    if (this.indicators[this.currentIndex]) {
      this.indicators[this.currentIndex].classList.remove('active');
    }

    // Update index
    this.currentIndex = index;

    // Add active class to new slide
    this.messages[this.currentIndex].classList.add('active');
    if (this.indicators[this.currentIndex]) {
      this.indicators[this.currentIndex].classList.add('active');
    }

    // Announce to screen readers
    this.announceSlideChange();
  }

  goToNext() {
    const nextIndex = (this.currentIndex + 1) % this.messages.length;
    this.goToSlide(nextIndex);
  }

  goToPrevious() {
    const prevIndex = (this.currentIndex - 1 + this.messages.length) % this.messages.length;
    this.goToSlide(prevIndex);
  }

  startAutoplay() {
    if (this.messages.length <= 1) return;

    this.intervalId = setInterval(() => {
      if (!this.isPaused) {
        this.goToNext();
      }
    }, this.speed);
  }

  stopAutoplay() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    if (this.isPlaying) {
      this.isPaused = false;
    }
  }

  announceSlideChange() {
    // Create a live region for screen readers
    const liveRegion = this.container.querySelector('.announcement-bar__live-region') ||
                      this.createLiveRegion();

    const currentMessage = this.messages[this.currentIndex];
    const messageText = currentMessage.querySelector('.announcement-bar__text').textContent;
    liveRegion.textContent = `Slide ${this.currentIndex + 1} of ${this.messages.length}: ${messageText}`;
  }

  createLiveRegion() {
    const liveRegion = document.createElement('div');
    liveRegion.className = 'announcement-bar__live-region sr-only';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    this.container.appendChild(liveRegion);
    return liveRegion;
  }

  destroy() {
    this.stopAutoplay();
  }
}

// Initialize announcement bars when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.announcement-bar').forEach(container => {
    new AnnouncementBar(container);
  });
});

// Handle section loading/unloading for theme editor
document.addEventListener('shopify:section:load', (e) => {
  const announcementBar = e.target.querySelector('.announcement-bar');
  if (announcementBar) {
    new AnnouncementBar(announcementBar);
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  const announcementBar = e.target.querySelector('.announcement-bar');
  if (announcementBar && announcementBar.announcementBarInstance) {
    announcementBar.announcementBarInstance.destroy();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const tocContainer = document.querySelector("[data-article-toc]");
    const tocList = document.querySelector("[data-toc-list]");
    const tocToggle = document.querySelector("[data-toc-toggle]");
    const articleBody = document.querySelector(".article-body");
    if (!tocContainer || !tocList || !articleBody) return;
    const headings = articleBody.querySelectorAll("h2, h3");
    if (headings.length === 0) {
        tocContainer.style.display = "none";
        return;
    }
    headings.forEach((heading, index) => {
        if (!heading.id) {
            const id = "heading-" + (index + 1) + "-" + heading.textContent.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
            heading.id = id;
        }
        const li = document.createElement("li");
        li.className = "article-toc__item";
        if (heading.tagName.toLowerCase() === "h3") {
            li.classList.add("article-toc__item--h3");
        }
        const link = document.createElement("a");
        link.href = "#" + heading.id;
        link.className = "article-toc__link";
        link.textContent = heading.textContent;
        link.setAttribute("data-toc-link", "");
        li.appendChild(link);
        tocList.appendChild(li);
    });
    if (tocToggle) {
        tocToggle.addEventListener("click", function() {
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            if (isExpanded) {
                this.setAttribute("aria-expanded", "false");
                tocList.setAttribute("hidden", "");
            } else {
                this.setAttribute("aria-expanded", "true");
                tocList.removeAttribute("hidden");
            }
        });
    }
    const tocLinks = tocList.querySelectorAll("[data-toc-link]");
    tocLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").substring(1);
            const targetHeading = document.getElementById(targetId);
            if (targetHeading) {
                const headerHeight = document.querySelector(".chemistrie-header")?.offsetHeight || 80;
                const offset = headerHeight + 20;
                const targetPosition = targetHeading.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
                updateActiveTocLink(this);
            }
        });
    });
    let ticking = false;
    function updateActiveSectionOnScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                const headerHeight = document.querySelector(".chemistrie-header")?.offsetHeight || 80;
                const scrollPosition = window.scrollY + headerHeight + 50;
                let activeHeading = null;
                headings.forEach(heading => {
                    const headingTop = heading.offsetTop;
                    if (scrollPosition >= headingTop) {
                        activeHeading = heading;
                    }
                });
                if (activeHeading) {
                    const activeLink = tocList.querySelector(`[href="#${activeHeading.id}"]`);
                    updateActiveTocLink(activeLink);
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    function updateActiveTocLink(activeLink) {
        tocLinks.forEach(link => link.classList.remove("is-active"));
        if (activeLink) {
            activeLink.classList.add("is-active");
        }
    }
    window.addEventListener("scroll", updateActiveSectionOnScroll, {
        passive: true
    });
    updateActiveSectionOnScroll();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Redirect to homepage and trigger cart drawer to open
  if (window.location.pathname === '/cart') {
    window.location.href = '/?open-cart=true';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-how-it-works"] && !Shopify.designMode) return;
  try {
    (function() {
    function playVideo(v) {
        if (!v.dataset.loaded) {
            v.dataset.loaded = "1";
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            if (!v.getAttribute("src") && v.dataset.src) {
                v.src = v.dataset.src;
            }
            v.load();
        }
        var p = v.play();
        if (p && p.catch) {
            p.catch(function() {});
        }
    }
    function ensureObserver() {
        if (!window.__chemInviewIO) {
            if ("IntersectionObserver" in window) {
                window.__chemInviewIO = new IntersectionObserver(function(entries) {
                    entries.forEach(function(e) {
                        if (e.isIntersecting) {
                            playVideo(e.target);
                        } else if (!e.target.paused) {
                            e.target.pause();
                        }
                    });
                }, {
                    rootMargin: "200px 0px"
                });
            } else {
                window.__chemInviewIO = {
                    observe: function(v) {
                        playVideo(v);
                    }
                };
            }
        }
        document.querySelectorAll("[data-inview-video]:not([data-observed])").forEach(function(v) {
            v.setAttribute("data-observed", "1");
            window.__chemInviewIO.observe(v);
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", ensureObserver);
    } else {
        ensureObserver();
    }
    document.addEventListener("shopify:section:load", ensureObserver);
})();

(function() {
    "use strict";
    let steps = [];
    let stepImages = [];
    let currentActiveStep = 1;
    function init() {
        const section = document.querySelector(".clips-how-it-works");
        if (!section) return;
        steps = Array.from(section.querySelectorAll(".clips-how-it-works__step"));
        stepImages = Array.from(section.querySelectorAll(".clips-how-it-works__step-image"));
        steps.forEach(step => {
            step.addEventListener("mouseenter", () => handleStepHover(step));
            step.addEventListener("click", () => handleStepClick(step));
        });
    }
    function handleStepHover(step) {
        const stepNumber = parseInt(step.getAttribute("data-step"));
        switchToStep(stepNumber);
    }
    function handleStepClick(step) {
        const stepNumber = parseInt(step.getAttribute("data-step"));
        switchToStep(stepNumber, true);
    }
    function switchToStep(stepNumber, isClick = false) {
        if (stepNumber === currentActiveStep) return;
        if (typeof gsap === "undefined") {
            switchToStepFallback(stepNumber);
            return;
        }
        const previousStep = currentActiveStep;
        currentActiveStep = stepNumber;
        const currentImage = stepImages.find(img => img.getAttribute("data-step-image") === String(previousStep));
        const newImage = stepImages.find(img => img.getAttribute("data-step-image") === String(stepNumber));
        const currentStepEl = steps.find(s => s.getAttribute("data-step") === String(previousStep));
        const newStepEl = steps.find(s => s.getAttribute("data-step") === String(stepNumber));
        steps.forEach(s => s.classList.remove("active"));
        if (newStepEl) {
            newStepEl.classList.add("active");
        }
        const tl = gsap.timeline();
        if (currentImage) {
            tl.to(currentImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.in",
                onComplete: () => {
                    currentImage.classList.remove("active");
                }
            });
        }
        if (newImage) {
            tl.set(newImage, {
                opacity: 0,
                scale: 1.05
            }).add(() => {
                newImage.classList.add("active");
                const vid = newImage.querySelector("video");
                if (vid && vid.paused) vid.play().catch(() => {});
            }).to(newImage, {
                opacity: 1,
                scale: 1,
                duration: .5,
                ease: "power2.out"
            }, "-=0.1");
        }
        if (isClick && newStepEl) {
            const circle = newStepEl.querySelector(".clips-how-it-works__step-circle");
            gsap.fromTo(circle, {
                scale: .95
            }, {
                scale: 1,
                duration: .4,
                ease: "elastic.out(1, 0.6)"
            });
        }
    }
    function switchToStepFallback(stepNumber) {
        const previousStep = currentActiveStep;
        currentActiveStep = stepNumber;
        const currentImage = stepImages.find(img => img.getAttribute("data-step-image") === String(previousStep));
        const newImage = stepImages.find(img => img.getAttribute("data-step-image") === String(stepNumber));
        const newStepEl = steps.find(s => s.getAttribute("data-step") === String(stepNumber));
        steps.forEach(s => s.classList.remove("active"));
        stepImages.forEach(img => img.classList.remove("active"));
        if (newStepEl) newStepEl.classList.add("active");
        if (newImage) {
            newImage.classList.add("active");
            const vid = newImage.querySelector("video");
            if (vid && vid.paused) vid.play().catch(() => {});
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-3d"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-bluelight"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-driving"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-light-sensitivity"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPColorSystem = {
        colorData: {
            colors: [ "Light", "Medium" ],
            displayPrefix: "FL-41",
            hexColors: {
                Light: "#dfc8c5",
                Medium: "#df978f"
            }
        },
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentColor: "Light",
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null,
            lensColorSpec: null,
            colorGrid: null
        },
        init() {
            if (!document.querySelector(".clips-pdp-hero--light-sensitivity")) return;
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Color System: Asset data not found");
                return;
            }
            this.cacheElements();
            this.renderColorPicker();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-color-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Color System: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero--light-sensitivity .clips-pdp-hero__thumbnail");
            this.elements.lensColorSpec = document.querySelector(".clips-pdp-hero--light-sensitivity [data-spec-lens]");
            this.elements.colorGrid = document.getElementById("pdpColorGrid");
        },
        renderColorPicker() {
            if (!this.elements.colorGrid) return;
            this.elements.colorGrid.innerHTML = "";
            this.colorData.colors.forEach(colorName => {
                const puck = this.createColorPuck(colorName);
                this.elements.colorGrid.appendChild(puck);
            });
        },
        createColorPuck(colorName) {
            const puck = document.createElement("button");
            puck.className = "pdp-color-puck";
            puck.setAttribute("data-color", colorName);
            puck.setAttribute("aria-label", `Select FL-41 ${colorName} lens`);
            if (colorName === this.state.currentColor) {
                puck.classList.add("selected");
            }
            const hexColor = this.colorData.hexColors[colorName];
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "50");
            svg.setAttribute("height", "50");
            svg.setAttribute("viewBox", "0 0 50 50");
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", "25");
            circle.setAttribute("cy", "25");
            circle.setAttribute("r", "22");
            circle.setAttribute("fill", hexColor);
            circle.setAttribute("stroke", "#e0e0e0");
            circle.setAttribute("stroke-width", "2");
            svg.appendChild(circle);
            puck.appendChild(svg);
            const label = document.createElement("span");
            label.className = "pdp-color-puck__label";
            label.textContent = colorName;
            puck.appendChild(label);
            puck.addEventListener("click", () => {
                this.selectColor(colorName);
            });
            return puck;
        },
        selectColor(colorName) {
            if (this.state.isAnimating) return;
            this.state.currentColor = colorName;
            this.updateActivePuck(colorName);
            this.updateAllThumbnails();
            this.updateMainImage();
            this.updateProductSpecs();
        },
        updateActivePuck(colorName) {
            document.querySelectorAll(".clips-pdp-hero--light-sensitivity .pdp-color-puck").forEach(puck => {
                const puckColor = puck.getAttribute("data-color");
                if (puckColor === colorName) {
                    puck.classList.add("selected");
                } else {
                    puck.classList.remove("selected");
                }
            });
        },
        updateAllThumbnails() {
            this.elements.thumbnails.forEach((thumb, index) => {
                const imageType = this.imageTypes[index];
                const img = thumb.querySelector(".thumbnail-image");
                if (img) {
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(img, newSrc);
                }
            });
        },
        updateMainImage() {
            const activeThumbnail = document.querySelector(".clips-pdp-hero--light-sensitivity .clips-pdp-hero__thumbnail.active");
            if (!activeThumbnail) return;
            const imageType = activeThumbnail.getAttribute("data-image-type");
            const newSrc = this.getImageURL(imageType);
            this.animateImageChange(this.elements.mainImage, newSrc);
        },
        updateProductSpecs() {
            if (!this.elements.lensColorSpec) return;
            const lensText = `${this.colorData.displayPrefix} ${this.state.currentColor}`;
            this.elements.lensColorSpec.textContent = lensText;
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[this.state.currentColor][imageType];
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        preloadImages() {
            this.colorData.colors.forEach(colorName => {
                this.imageTypes.forEach(imageType => {
                    if (this.assetData.productImages[colorName]) {
                        const url = this.assetData.productImages[colorName][imageType];
                        const img = new Image;
                        img.src = url;
                    }
                });
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPColorSystem.init());
    } else {
        PDPColorSystem.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-migraine"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPMigraineGallery = {
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (!document.querySelector(".clips-pdp-hero--migraine")) return;
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Migraine Gallery: Asset data not found");
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-migraine-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Migraine Gallery: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero--migraine .clips-pdp-hero__thumbnail");
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[imageType];
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    if (this.state.isAnimating) return;
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        preloadImages() {
            this.imageTypes.forEach(imageType => {
                const url = this.assetData.productImages[imageType];
                const img = new Image;
                img.src = url;
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPMigraineGallery.init());
    } else {
        PDPMigraineGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-reader"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPColorSystem = {
        colorData: {
            gradient: {
                colors: [ "Amber", "CrimsonGrey", "DarkBrown", "DarkGrey", "MediumBrown", "Rouge", "VioletGrey", "VioletRose" ],
                displayPrefix: "Gradient"
            },
            mirror: {
                colors: [ "Blue", "Caliente", "Gold", "Green", "Morado", "Orange", "Silver", "SkyBlue" ],
                displayPrefix: "Mirror"
            },
            solid: {
                colors: [ "Amber", "Blue", "Bronze", "Brown", "G15", "Grey", "Rose", "Yellow" ],
                displayPrefix: "Solid"
            },
            "non-polarized": {
                colors: [ "Grey", "Brown", "G15" ],
                displayPrefix: "NP",
                displayNames: {
                    Grey: "NP Grey",
                    Brown: "NP Brown",
                    G15: "NP G-15"
                }
            }
        },
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentCategory: "gradient",
            currentColor: "Amber",
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null,
            lensColorSpec: null,
            colorGrid: null,
            categoryTabs: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Color System: Asset data not found");
                return;
            }
            this.cacheElements();
            this.renderColorPicker();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-color-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Color System: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
            this.elements.lensColorSpec = document.querySelector("[data-spec-lens]");
            this.elements.colorGrid = document.getElementById("pdpColorGrid");
            this.elements.categoryTabs = document.querySelectorAll(".pdp-category-tab");
        },
        renderColorPicker() {
            if (!this.elements.colorGrid) return;
            this.renderCategoryColors(this.state.currentCategory);
        },
        renderCategoryColors(category) {
            const categoryData = this.colorData[category];
            if (!categoryData) return;
            const colorGrid = this.elements.colorGrid;
            colorGrid.innerHTML = "";
            categoryData.colors.forEach(colorName => {
                const puck = this.createColorPuck(category, colorName);
                colorGrid.appendChild(puck);
            });
        },
        createColorPuck(category, colorName) {
            const puck = document.createElement("button");
            puck.className = "pdp-color-puck";
            puck.setAttribute("data-category", category);
            puck.setAttribute("data-color", colorName);
            puck.setAttribute("aria-label", `Select ${this.formatColorDisplay(category, colorName)} lens`);
            if (category === this.state.currentCategory && colorName === this.state.currentColor) {
                puck.classList.add("selected");
            }
            const puckSrc = this.assetData.colorPucks[category][colorName];
            const img = document.createElement("img");
            img.src = puckSrc;
            img.alt = this.formatColorDisplay(category, colorName);
            puck.appendChild(img);
            const label = document.createElement("span");
            label.className = "pdp-color-puck__label";
            label.textContent = this.colorData[category].displayNames && this.colorData[category].displayNames[colorName] ? this.colorData[category].displayNames[colorName] : colorName.replace(/([A-Z])/g, " $1").trim();
            puck.appendChild(label);
            puck.addEventListener("click", () => {
                this.selectColor(category, colorName);
            });
            return puck;
        },
        selectColor(category, colorName) {
            if (this.state.isAnimating) return;
            this.state.currentCategory = category;
            this.state.currentColor = colorName;
            this.updateActivePuck(category, colorName);
            this.updateAllThumbnails();
            this.updateMainImage();
            this.updateProductSpecs();
        },
        updateActivePuck(category, colorName) {
            document.querySelectorAll(".pdp-color-puck").forEach(puck => {
                const puckCategory = puck.getAttribute("data-category");
                const puckColor = puck.getAttribute("data-color");
                if (puckCategory === category && puckColor === colorName) {
                    puck.classList.add("selected");
                } else {
                    puck.classList.remove("selected");
                }
            });
        },
        updateAllThumbnails() {
            this.elements.thumbnails.forEach((thumb, index) => {
                const imageType = this.imageTypes[index];
                const img = thumb.querySelector(".thumbnail-image");
                if (img) {
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(img, newSrc);
                }
            });
        },
        updateMainImage() {
            const activeThumbnail = document.querySelector(".clips-pdp-hero__thumbnail.active");
            if (!activeThumbnail) return;
            const imageType = activeThumbnail.getAttribute("data-image-type");
            const newSrc = this.getImageURL(imageType);
            this.animateImageChange(this.elements.mainImage, newSrc);
        },
        updateProductSpecs() {
            if (!this.elements.lensColorSpec) return;
            let lensText = this.formatColorDisplay(this.state.currentCategory, this.state.currentColor);
            this.elements.lensColorSpec.textContent = lensText;
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[this.state.currentCategory][this.state.currentColor][imageType];
        },
        attachEventListeners() {
            this.elements.categoryTabs.forEach(tab => {
                tab.addEventListener("click", () => {
                    const category = tab.getAttribute("data-category");
                    this.switchCategory(category);
                });
            });
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        switchCategory(category) {
            this.elements.categoryTabs.forEach(tab => {
                if (tab.getAttribute("data-category") === category) {
                    tab.classList.add("active");
                } else {
                    tab.classList.remove("active");
                }
            });
            this.renderCategoryColors(category);
        },
        preloadImages() {
            Object.keys(this.colorData).forEach(category => {
                this.colorData[category].colors.forEach(colorName => {
                    this.imageTypes.forEach(imageType => {
                        if (this.assetData.productImages[category] && this.assetData.productImages[category][colorName]) {
                            const url = this.assetData.productImages[category][colorName][imageType];
                            const img = new Image;
                            img.src = url;
                        }
                    });
                });
            });
        },
        formatColorDisplay(category, colorName) {
            const categoryData = this.colorData[category];
            if (categoryData.displayNames && categoryData.displayNames[colorName]) {
                return categoryData.displayNames[colorName];
            }
            const prefix = categoryData.displayPrefix;
            const formattedColor = colorName.replace(/([A-Z])/g, " $1").trim();
            return `${prefix} ${formattedColor}`;
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPColorSystem.init());
    } else {
        PDPColorSystem.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-plp-collection-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    var cards = document.querySelectorAll(".clips-plp-grid__card");
    if (!cards.length) return;
    if (typeof gsap !== "undefined") {
        gsap.set(cards, {
            opacity: 0,
            y: 24
        });
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var visibleCards = Array.from(cards).filter(function(card) {
                        var rect = card.getBoundingClientRect();
                        return rect.top < window.innerHeight;
                    });
                    gsap.to(visibleCards, {
                        opacity: 1,
                        y: 0,
                        duration: .5,
                        stagger: .1,
                        ease: "power2.out",
                        onComplete: function() {
                            visibleCards.forEach(function(card) {
                                card.classList.add("is-visible");
                            });
                        }
                    });
                    observer.disconnect();
                }
            });
        }, {
            threshold: .1
        });
        observer.observe(cards[0]);
    } else {
        cards.forEach(function(card) {
            card.style.opacity = "1";
            card.style.transform = "none";
            card.classList.add("is-visible");
        });
    }
    window.addEventListener("clips-plp-recommend", function(e) {
        var clipType = e.detail && e.detail.clipType;
        cards.forEach(function(card) {
            card.removeAttribute("data-recommended");
        });
        if (clipType) {
            var match = document.querySelector('.clips-plp-grid__card[data-clip-type="' + clipType + '"]');
            if (match) {
                match.setAttribute("data-recommended", "true");
            }
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-plp-finder"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    var finderCard = document.getElementById("clips-finder-card");
    var tiles = document.querySelectorAll(".clips-finder__tile");
    var skipBtn = document.getElementById("clips-finder-skip");
    if (!finderCard || !tiles.length) return;
    function selectTile(clipType) {
        tiles.forEach(function(t) {
            t.classList.remove("is-selected");
        });
        var selected = document.querySelector('.clips-finder__tile[data-clip-type="' + clipType + '"]');
        if (selected) {
            selected.classList.add("is-selected");
        }
        window.dispatchEvent(new CustomEvent("clips-plp-recommend", {
            detail: {
                clipType: clipType
            }
        }));
        var recSection = document.getElementById("clips-recommendation");
        if (recSection) {
            setTimeout(function() {
                recSection.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }, 200);
        }
    }
    tiles.forEach(function(tile) {
        tile.addEventListener("click", function() {
            var clipType = tile.getAttribute("data-clip-type");
            selectTile(clipType);
        });
    });
    if (skipBtn) {
        skipBtn.addEventListener("click", function() {
            var recSection = document.getElementById("clips-recommendation");
            if (recSection) {
                recSection.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        });
    }
    if (typeof gsap !== "undefined") {
        gsap.to(tiles, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: .4,
            stagger: .08,
            ease: "power2.out",
            delay: .2
        });
    } else {
        tiles.forEach(function(tile) {
            tile.style.opacity = "1";
            tile.style.transform = "none";
        });
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-plp-recommendation"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    var section = document.getElementById("clips-recommendation");
    if (!section) return;
    var cards = Array.from(section.querySelectorAll(".clips-rec__card"));
    var dots = Array.from(section.querySelectorAll(".clips-rec__dot"));
    var prevBtn = section.querySelector(".clips-rec__arrow--prev");
    var nextBtn = section.querySelector(".clips-rec__arrow--next");
    var backTopBtn = document.getElementById("clips-back-to-finder");
    var currentIndex = 0;
    var defaultCard = section.querySelector('.clips-rec__card[data-default="true"]');
    if (defaultCard) {
        currentIndex = cards.indexOf(defaultCard);
    }
    function showCard(index, animate) {
        if (index < 0) index = cards.length - 1;
        if (index >= cards.length) index = 0;
        currentIndex = index;
        cards.forEach(function(c) {
            c.classList.remove("is-active", "is-visible");
        });
        dots.forEach(function(d) {
            d.classList.remove("is-active");
        });
        var card = cards[index];
        if (!card) return;
        card.classList.add("is-active");
        if (dots[index]) dots[index].classList.add("is-active");
        if (animate && typeof gsap !== "undefined") {
            gsap.fromTo(card, {
                opacity: 0,
                x: 30
            }, {
                opacity: 1,
                x: 0,
                duration: .4,
                ease: "power2.out",
                onComplete: function() {
                    card.classList.add("is-visible");
                }
            });
        } else {
            card.classList.add("is-visible");
            card.style.opacity = "1";
            card.style.transform = "none";
        }
    }
    if (prevBtn) {
        prevBtn.addEventListener("click", function() {
            showCard(currentIndex - 1, true);
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener("click", function() {
            showCard(currentIndex + 1, true);
        });
    }
    dots.forEach(function(dot) {
        dot.addEventListener("click", function() {
            var idx = parseInt(dot.getAttribute("data-index"), 10);
            showCard(idx, true);
        });
    });
    window.addEventListener("clips-plp-recommend", function(e) {
        var clipType = e.detail && e.detail.clipType;
        if (clipType) {
            var idx = cards.findIndex(function(c) {
                return c.getAttribute("data-clip-type") === clipType;
            });
            if (idx !== -1) {
                showCard(idx, true);
            }
        }
    });
    if (backTopBtn) {
        backTopBtn.addEventListener("click", function() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }
    showCard(currentIndex, false);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-summary"] && !Shopify.designMode) return;
  try {
    (function() {
    function playVideo(v) {
        if (!v.dataset.loaded) {
            v.dataset.loaded = "1";
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            if (!v.getAttribute("src") && v.dataset.src) {
                v.src = v.dataset.src;
            }
            v.load();
        }
        var p = v.play();
        if (p && p.catch) {
            p.catch(function() {});
        }
    }
    function ensureObserver() {
        if (!window.__chemInviewIO) {
            if ("IntersectionObserver" in window) {
                window.__chemInviewIO = new IntersectionObserver(function(entries) {
                    entries.forEach(function(e) {
                        if (e.isIntersecting) {
                            playVideo(e.target);
                        } else if (!e.target.paused) {
                            e.target.pause();
                        }
                    });
                }, {
                    rootMargin: "200px 0px"
                });
            } else {
                window.__chemInviewIO = {
                    observe: function(v) {
                        playVideo(v);
                    }
                };
            }
        }
        document.querySelectorAll("[data-inview-video]:not([data-observed])").forEach(function(v) {
            v.setAttribute("data-observed", "1");
            window.__chemInviewIO.observe(v);
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", ensureObserver);
    } else {
        ensureObserver();
    }
    document.addEventListener("shopify:section:load", ensureObserver);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-technical"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 3D Parallax Mouse Tracking Effect for Clips Technical Section
  const container = document.getElementById('clips-parallax-container');
  const image = document.getElementById('clips-parallax-image');

  if (!container || !image) return;

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // Check if mobile device
  const isMobile = window.innerWidth <= 768;

  // Animation configuration (reduced by 75% from original)
  const config = {
    rotationRange: isMobile ? 2 : 3.75,     // Maximum rotation in degrees
    translationRange: isMobile ? 2.5 : 5,   // Maximum translation in pixels
    scaleRange: isMobile ? 0.005 : 0.0125,  // Scale variation
    perspective: 1200,                       // 3D perspective
    smooth: 0.1,                            // Animation smoothness (0-1)
    zTranslation: isMobile ? 3.75 : 7.5     // Z-axis movement
  };

  let isActive = false;
  let animationId = null;
  let targetTransform = {
    rotateX: 0,
    rotateY: 0,
    translateX: 0,
    translateY: 0,
    translateZ: 0,
    scale: isMobile ? 1.0 : 1.05
  };

  let currentTransform = { ...targetTransform };

  // Smooth animation loop
  function animate() {
    // Interpolate current values towards target values
    currentTransform.rotateX += (targetTransform.rotateX - currentTransform.rotateX) * config.smooth;
    currentTransform.rotateY += (targetTransform.rotateY - currentTransform.rotateY) * config.smooth;
    currentTransform.translateX += (targetTransform.translateX - currentTransform.translateX) * config.smooth;
    currentTransform.translateY += (targetTransform.translateY - currentTransform.translateY) * config.smooth;
    currentTransform.translateZ += (targetTransform.translateZ - currentTransform.translateZ) * config.smooth;
    currentTransform.scale += (targetTransform.scale - currentTransform.scale) * config.smooth;

    // Apply transforms to image
    const transform = `
      perspective(${config.perspective}px)
      rotateX(${currentTransform.rotateX}deg)
      rotateY(${currentTransform.rotateY}deg)
      translateX(${currentTransform.translateX}px)
      translateY(${currentTransform.translateY}px)
      translateZ(${currentTransform.translateZ}px)
      scale(${currentTransform.scale})
    `;

    image.style.transform = transform;

    // Continue animation if active
    if (isActive) {
      animationId = requestAnimationFrame(animate);
    }
  }

  // Calculate parallax values based on mouse position
  function updateParallax(x, y) {
    const rect = container.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // Calculate relative position (-1 to 1)
    const relativeX = (x - centerX) / (rect.width / 2);
    const relativeY = (y - centerY) / (rect.height / 2);

    // Apply easing function for smoother feel
    const easedX = relativeX * Math.abs(relativeX);
    const easedY = relativeY * Math.abs(relativeY);

    // Calculate target transforms
    targetTransform.rotateY = easedX * config.rotationRange;
    targetTransform.rotateX = -easedY * config.rotationRange;
    targetTransform.translateX = easedX * config.translationRange;
    targetTransform.translateY = easedY * config.translationRange;
    targetTransform.translateZ = config.zTranslation;
    targetTransform.scale = (isMobile ? 1.0 : 1.05) + Math.abs(easedX + easedY) * 0.5 * config.scaleRange;
  }

  // Reset to neutral position
  function resetParallax() {
    targetTransform = {
      rotateX: 0,
      rotateY: 0,
      translateX: 0,
      translateY: 0,
      translateZ: 0,
      scale: isMobile ? 1.0 : 1.05
    };
  }

  // Event handlers
  function handleMouseEnter() {
    if (!isActive) {
      isActive = true;
      image.classList.add('parallax-active');
      animate();
    }
  }

  function handleMouseMove(e) {
    if (isActive) {
      updateParallax(e.clientX, e.clientY);
    }
  }

  function handleMouseLeave() {
    isActive = false;
    image.classList.remove('parallax-active');
    resetParallax();

    // Continue animation briefly to smooth the exit
    if (animationId) {
      cancelAnimationFrame(animationId);
    }

    const exitAnimation = () => {
      const hasMovement = Math.abs(currentTransform.rotateX) > 0.1 ||
                         Math.abs(currentTransform.rotateY) > 0.1 ||
                         Math.abs(currentTransform.translateX) > 0.1 ||
                         Math.abs(currentTransform.translateY) > 0.1 ||
                         Math.abs(currentTransform.translateZ) > 0.1;

      if (hasMovement) {
        animate();
        requestAnimationFrame(exitAnimation);
      }
    };

    exitAnimation();
  }

  // Touch events for mobile (simplified)
  function handleTouchStart(e) {
    if (isMobile && e.touches.length === 1) {
      handleMouseEnter();
      const touch = e.touches[0];
      updateParallax(touch.clientX, touch.clientY);
    }
  }

  function handleTouchMove(e) {
    if (isMobile && e.touches.length === 1) {
      e.preventDefault(); // Prevent scrolling while interacting
      const touch = e.touches[0];
      updateParallax(touch.clientX, touch.clientY);
    }
  }

  function handleTouchEnd() {
    if (isMobile) {
      setTimeout(handleMouseLeave, 100); // Brief delay for mobile
    }
  }

  // Attach event listeners
  if (!isMobile) {
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);
  } else {
    container.addEventListener('touchstart', handleTouchStart, { passive: false });
    container.addEventListener('touchmove', handleTouchMove, { passive: false });
    container.addEventListener('touchend', handleTouchEnd);
  }

  // Handle window resize
  function handleResize() {
    // Reset animation on resize
    if (isActive) {
      resetParallax();
    }
  }

  window.addEventListener('resize', handleResize);

  // Cleanup function (useful for SPAs)
  window.clipsParallaxCleanup = function() {
    if (animationId) {
      cancelAnimationFrame(animationId);
    }
    container.removeEventListener('mouseenter', handleMouseEnter);
    container.removeEventListener('mousemove', handleMouseMove);
    container.removeEventListener('mouseleave', handleMouseLeave);
    container.removeEventListener('touchstart', handleTouchStart);
    container.removeEventListener('touchmove', handleTouchMove);
    container.removeEventListener('touchend', handleTouchEnd);
    window.removeEventListener('resize', handleResize);
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-faq-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const faqLinkCards = document.querySelectorAll('.faq-link-card[data-action="faq-search"]');
    faqLinkCards.forEach(card => {
        card.addEventListener("click", function(e) {
            e.preventDefault();
            const searchQuery = this.dataset.search;
            const faqUrl = this.dataset.faqUrl || "/pages/faq";
            if (searchQuery) {
                window.location.href = `${faqUrl}?search=${encodeURIComponent(searchQuery)}`;
            }
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-help-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const helpCategoryCards = document.querySelectorAll(".help-category-card[data-action]");
    helpCategoryCards.forEach(card => {
        card.addEventListener("click", function(e) {
            const action = this.dataset.action;
            switch (action) {
              case "faq-search":
                const searchQuery = this.dataset.search;
                const faqUrl = this.dataset.faqUrl || "/pages/faq";
                window.location.href = `${faqUrl}?search=${encodeURIComponent(searchQuery)}`;
                break;

              case "faq-category":
                const category = this.dataset.category;
                const faqCategoryUrl = this.dataset.faqUrl || "/pages/faq";
                window.location.href = `${faqCategoryUrl}?category=${encodeURIComponent(category)}`;
                break;

              case "contact-form":
                const subject = this.dataset.subject;
                scrollToContactForm(subject);
                break;
            }
        });
    });
    function scrollToContactForm(subject) {
        const contactFormSection = document.querySelector(".contact-form-locator") || document.querySelector(".contact-form-section");
        const subjectSelect = document.getElementById("contact-subject");
        if (contactFormSection) {
            const rect = contactFormSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let headerOffset = 0;
            const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
            const announcementBar = document.querySelector(".announcement-bar");
            const regularHeader = document.querySelector(".chemistrie-header");
            if (stickyHeader || regularHeader) {
                headerOffset = announcementBar ? 120 : 84;
            }
            const targetPosition = rect.top + scrollTop - headerOffset - 20;
            window.scrollTo({
                top: Math.max(0, targetPosition),
                behavior: "smooth"
            });
            if (subjectSelect && subject) {
                setTimeout(() => {
                    const options = subjectSelect.options;
                    for (let i = 0; i < options.length; i++) {
                        if (options[i].value === subject) {
                            subjectSelect.selectedIndex = i;
                            subjectSelect.dispatchEvent(new Event("change", {
                                bubbles: true
                            }));
                            break;
                        }
                    }
                    const formWrapper = contactFormSection.querySelector(".contact-form-locator__form-wrapper") || contactFormSection.querySelector(".contact-form__wrapper");
                    if (formWrapper) {
                        formWrapper.classList.add("contact-form-locator--highlighted", "contact-form--highlighted");
                        setTimeout(() => {
                            formWrapper.classList.remove("contact-form-locator--highlighted", "contact-form--highlighted");
                        }, 2e3);
                    }
                    const nameInput = document.getElementById("contact-name");
                    if (nameInput && !nameInput.value) {
                        nameInput.focus();
                    }
                }, 500);
            }
            console.log("Contact Help: Scrolled to form with subject:", subject);
        } else {
            console.warn("Contact Help: Contact form section not found");
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-methods"] && !Shopify.designMode) return;
  try {
    window.openLiveChat = function() {
    alert("Live chat feature will be integrated with your chat service provider.");
    console.log("Opening live chat...");
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crystal-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var root = document.querySelector(".crystal-pdp");
    if (!root) return;
    var dataEl = document.getElementById("crystalPdpVariantData");
    if (!dataEl) return;
    var data;
    try {
        data = JSON.parse(dataEl.textContent);
    } catch (e) {
        console.error("[Crystal PDP] Could not parse variant data:", e);
        return;
    }
    var variants = data.variants || [];
    var moneyFormat = (data.moneyFormat || "").replace(/<[^>]*>/g, "");
    var hero = document.getElementById("crystalPdpHero");
    var overlay = document.getElementById("crystalPdpOverlay");
    var thumbOverlay = document.getElementById("crystalPdpThumbOverlay");
    var photo = document.getElementById("crystalPdpPhoto");
    var variantThumb = document.getElementById("crystalPdpVariantThumb");
    var variantThumbImg = document.getElementById("crystalPdpVariantThumbImg");
    var variantIdInput = document.getElementById("crystalPdpVariantId");
    var priceValue = document.getElementById("crystalPdpPriceValue");
    var priceCompare = document.getElementById("crystalPdpPriceCompare");
    var priceBadge = document.getElementById("crystalPdpPriceBadge");
    var addBtn = document.getElementById("crystalPdpAddBtn");
    var form = document.getElementById("crystalPdpForm");
    var optionInputs = root.querySelectorAll(".crystal-pdp__swatch-input");
    var thumbs = root.querySelectorAll(".crystal-pdp__thumb");
    var addBtnLabel = root.getAttribute("data-add-label") || "Add to Cart";
    var soldOutLabel = root.getAttribute("data-sold-out-label") || "Sold Out";
    var addingLabel = root.getAttribute("data-adding-label") || "Adding...";
    function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var parts = value.split(".");
        var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (!moneyFormat) return "$" + withCommas + "." + parts[1];
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, token) {
            switch (token) {
              case "amount":
                return withCommas + "." + parts[1];

              case "amount_no_decimals":
                return withCommas;

              case "amount_with_comma_separator":
                return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1];

              case "amount_no_decimals_with_comma_separator":
                return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

              default:
                return match;
            }
        });
    }
    function getSelectedOptions() {
        var selected = [];
        optionInputs.forEach(function(input) {
            if (input.checked) {
                var position = parseInt(input.dataset.optionPosition, 10) || 1;
                selected[position - 1] = input.value;
            }
        });
        return selected;
    }
    function findVariant(selected) {
        for (var i = 0; i < variants.length; i++) {
            var match = true;
            for (var j = 0; j < selected.length; j++) {
                if (variants[i].options[j] !== selected[j]) {
                    match = false;
                    break;
                }
            }
            if (match) return variants[i];
        }
        return null;
    }
    function setActiveThumb(target) {
        thumbs.forEach(function(t) {
            t.classList.remove("active");
        });
        if (target) target.classList.add("active");
    }
    function showPreview() {
        if (hero) hero.classList.remove("crystal-pdp__hero--photo");
    }
    function showPhoto(url, alt) {
        if (!photo || !url) return;
        if (typeof gsap !== "undefined" && hero && hero.classList.contains("crystal-pdp__hero--photo")) {
            gsap.to(photo, {
                opacity: 0,
                duration: .2,
                onComplete: function() {
                    photo.src = url;
                    photo.alt = alt || "";
                    gsap.to(photo, {
                        opacity: 1,
                        duration: .3
                    });
                }
            });
        } else {
            photo.src = url;
            photo.alt = alt || "";
            if (hero) hero.classList.add("crystal-pdp__hero--photo");
        }
    }
    thumbs.forEach(function(thumb) {
        thumb.addEventListener("click", function() {
            setActiveThumb(thumb);
            var view = thumb.dataset.view;
            if (view === "preview") {
                showPreview();
            } else if (view === "variant") {
                var current = findVariant(getSelectedOptions());
                showPhoto(current && current.image, "");
            } else {
                showPhoto(thumb.dataset.imageUrl, thumb.querySelector("img") ? thumb.querySelector("img").alt : "");
            }
        });
    });
    var zoomOverlayLayer = document.getElementById("crystalPdpZoomOverlayLayer");
    function updateOverlay(input) {
        var src = input && input.dataset ? input.dataset.overlay : null;
        if (!src) return;
        if (overlay) overlay.src = src;
        if (thumbOverlay) thumbOverlay.src = src;
        if (zoomOverlayLayer) zoomOverlayLayer.src = src;
    }
    function updateSelectedLabel(input) {
        var position = input.dataset.optionPosition;
        var label = root.querySelector('.crystal-pdp__option-selected[data-option-position="' + position + '"]');
        if (label) label.textContent = input.value;
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceValue) priceValue.textContent = formatMoney(variant.price);
        var onSale = variant.compareAtPrice && variant.compareAtPrice > variant.price;
        if (priceCompare) {
            priceCompare.textContent = onSale ? formatMoney(variant.compareAtPrice) : "";
            priceCompare.hidden = !onSale;
        }
        if (priceBadge) priceBadge.hidden = !onSale;
        if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? addBtnLabel : soldOutLabel;
        }
        var stockEl = document.getElementById("crystalPdpStock");
        if (stockEl) {
            stockEl.innerHTML = variant.available ? '<span class="crystal-pdp__stock-in">' + (root.getAttribute("data-in-stock-label") || "In Stock") + "</span>" : '<span class="crystal-pdp__stock-out">' + (root.getAttribute("data-out-stock-label") || "Out of Stock") + "</span>";
        }
        var installments = document.querySelector("shopify-payment-terms");
        if (installments) installments.setAttribute("variant-id", variant.id);
        var wasViewingVariantPhoto = variantThumb && variantThumb.classList.contains("active");
        if (variantThumb) {
            if (variant.thumb) {
                variantThumb.hidden = false;
                if (variantThumbImg) variantThumbImg.src = variant.thumb;
                if (wasViewingVariantPhoto) showPhoto(variant.image, "");
            } else {
                variantThumb.hidden = true;
                if (wasViewingVariantPhoto) {
                    var previewThumb = root.querySelector(".crystal-pdp__thumb--preview");
                    setActiveThumb(previewThumb);
                    showPreview();
                }
            }
        }
        if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url.toString());
        }
    }
    optionInputs.forEach(function(input) {
        input.addEventListener("change", function() {
            updateSelectedLabel(input);
            updateOverlay(input);
            updateVariantUI(findVariant(getSelectedOptions()));
        });
    });
    var enlargeBtn = document.getElementById("crystalPdpEnlargeBtn");
    var zoomModal = document.getElementById("crystalPdpZoomModal");
    var zoomImage = document.getElementById("crystalPdpZoomImage");
    var zoomOverlayEl = document.getElementById("crystalPdpZoomOverlay");
    var zoomCloseBtn = document.getElementById("crystalPdpZoomClose");
    function openZoom() {
        if (!zoomModal) return;
        var showingPhoto = hero && hero.classList.contains("crystal-pdp__hero--photo");
        zoomModal.classList.toggle("crystal-pdp__zoom-modal--photo", !!showingPhoto);
        zoomModal.classList.toggle("crystal-pdp__zoom-modal--preview", !showingPhoto);
        if (showingPhoto && zoomImage && photo) {
            zoomImage.src = photo.src;
            zoomImage.alt = photo.alt || "";
        }
        zoomModal.classList.add("active");
        zoomModal.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        if (typeof gsap !== "undefined") {
            gsap.fromTo(zoomModal, {
                opacity: 0
            }, {
                opacity: 1,
                duration: .3
            });
        } else {
            zoomModal.style.opacity = "1";
        }
    }
    function closeZoom() {
        if (!zoomModal) return;
        var finish = function() {
            zoomModal.classList.remove("active");
            zoomModal.setAttribute("aria-hidden", "true");
            document.body.style.overflow = "";
        };
        if (typeof gsap !== "undefined") {
            gsap.to(zoomModal, {
                opacity: 0,
                duration: .25,
                onComplete: finish
            });
        } else {
            zoomModal.style.opacity = "0";
            finish();
        }
    }
    if (enlargeBtn) enlargeBtn.addEventListener("click", openZoom);
    if (zoomCloseBtn) zoomCloseBtn.addEventListener("click", closeZoom);
    if (zoomOverlayEl) zoomOverlayEl.addEventListener("click", closeZoom);
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && zoomModal && zoomModal.classList.contains("active")) {
            closeZoom();
        }
    });
    var qtyInput = document.getElementById("CrystalQuantity");
    root.querySelectorAll(".crystal-pdp__quantity-btn").forEach(function(btn) {
        btn.addEventListener("click", function() {
            if (!qtyInput) return;
            var current = parseInt(qtyInput.value, 10) || 1;
            var next = btn.dataset.action === "increase" ? current + 1 : current - 1;
            qtyInput.value = next < 1 ? 1 : next;
        });
    });
    if (form) {
        form.addEventListener("submit", async function(e) {
            e.preventDefault();
            if (!addBtn || addBtn.disabled) return;
            var original = addBtn.textContent;
            addBtn.disabled = true;
            addBtn.textContent = addingLabel;
            try {
                var response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: variantIdInput ? variantIdInput.value : null,
                        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) throw new Error("Add to cart failed with status " + response.status);
                var result = await response.json();
                if (window.cartDrawer && result.sections) {
                    window.cartDrawer.updateCartSections(result.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: result.items ? result.items[0] : result,
                        sections: result.sections
                    }
                }));
                if (window.cartDrawer && typeof window.cartDrawer.openDrawer === "function") {
                    window.cartDrawer.openDrawer();
                }
            } catch (error) {
                console.error("[Crystal PDP] Error adding to cart:", error);
                alert("Sorry, there was an error adding this item to your cart. Please try again.");
            } finally {
                addBtn.disabled = false;
                addBtn.textContent = original;
            }
        });
    }
    var checked = root.querySelector(".crystal-pdp__swatch-input[data-overlay]:checked");
    if (checked) updateOverlay(checked);
    root.querySelectorAll(".crystal-pdp__swatch-input[data-overlay]").forEach(function(input) {
        var img = new Image;
        img.src = input.dataset.overlay;
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-how-it-works"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    let steps = [];
    let stepImages = [];
    let currentActiveStep = 1;
    function init() {
        const section = document.querySelector(".eyeglasses-how-it-works");
        if (!section) return;
        steps = Array.from(section.querySelectorAll(".eyeglasses-how-it-works__step"));
        stepImages = Array.from(section.querySelectorAll(".eyeglasses-how-it-works__step-image"));
        steps.forEach(step => {
            step.addEventListener("mouseenter", () => handleStepHover(step));
            step.addEventListener("click", () => handleStepClick(step));
        });
    }
    function handleStepHover(step) {
        const stepNumber = parseInt(step.getAttribute("data-step"));
        switchToStep(stepNumber);
    }
    function handleStepClick(step) {
        const stepNumber = parseInt(step.getAttribute("data-step"));
        switchToStep(stepNumber, true);
    }
    function switchToStep(stepNumber, isClick = false) {
        if (stepNumber === currentActiveStep) return;
        const previousStep = currentActiveStep;
        currentActiveStep = stepNumber;
        const currentImage = stepImages.find(img => img.getAttribute("data-step-image") === String(previousStep));
        const newImage = stepImages.find(img => img.getAttribute("data-step-image") === String(stepNumber));
        const currentStepEl = steps.find(s => s.getAttribute("data-step") === String(previousStep));
        const newStepEl = steps.find(s => s.getAttribute("data-step") === String(stepNumber));
        steps.forEach(s => s.classList.remove("active"));
        if (newStepEl) {
            newStepEl.classList.add("active");
        }
        stepImages.forEach(img => img.classList.remove("active"));
        if (newImage) {
            newImage.classList.add("active");
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const tabBtns = document.querySelectorAll(".eyeglasses-pdp-main__tab-btn");
    const tabContents = document.querySelectorAll(".eyeglasses-pdp-main__tab-content");
    if (tabBtns.length) {
        tabBtns.forEach(btn => {
            btn.addEventListener("click", () => {
                const targetTab = btn.getAttribute("data-tab");
                tabBtns.forEach(b => {
                    b.classList.remove("active");
                    b.setAttribute("aria-selected", "false");
                });
                btn.classList.add("active");
                btn.setAttribute("aria-selected", "true");
                tabContents.forEach(content => {
                    content.classList.remove("active");
                    if (content.id === `tab-${targetTab}`) {
                        content.classList.add("active");
                    }
                });
            });
        });
    }
    const thumbnails = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
    const mainImage = document.getElementById("mainProductImage");
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl && typeof gsap !== "undefined") {
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: .2,
                        onComplete: () => {
                            mainImage.src = newImageUrl;
                            gsap.to(mainImage, {
                                opacity: 1,
                                duration: .3
                            });
                        }
                    });
                } else if (newImageUrl) {
                    mainImage.src = newImageUrl;
                }
            });
        });
    }
    const quantityInput = document.getElementById("Quantity");
    const decreaseBtn = document.querySelector('[data-action="decrease"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');
    if (quantityInput && decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
        increaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
        });
    }
    const variantInputs = document.querySelectorAll(".eyeglasses-pdp-main__option-input");
    const variantDataElement = document.getElementById("productVariantData");
    const variantIdInput = document.getElementById("productVariantId");
    const priceElement = document.getElementById("priceValue");
    const stockStatusElement = document.getElementById("stockStatus");
    const mainImageEl = document.getElementById("mainProductImage");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("Failed to parse variant data:", e);
        }
    }
    function findVariantByOptions(selectedOptions) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(variant => selectedOptions.every((option, index) => variant.options[index] === option));
    }
    function getSelectedOptions() {
        const options = [];
        const optionGroups = document.querySelectorAll(".eyeglasses-pdp-main__option");
        optionGroups.forEach(group => {
            const checkedInput = group.querySelector(".eyeglasses-pdp-main__option-input:checked");
            if (checkedInput) {
                options.push(checkedInput.value);
            }
        });
        return options;
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateMainImage(imageUrl) {
        if (!mainImageEl || !imageUrl) return;
        if (mainImageEl.src === imageUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(mainImageEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    mainImageEl.src = imageUrl;
                    mainImageEl.onload = () => {
                        gsap.to(mainImageEl, {
                            opacity: 1,
                            duration: .3
                        });
                    };
                }
            });
        } else {
            mainImageEl.src = imageUrl;
        }
    }
    function updateThumbnailSelection(imageUrl) {
        if (!imageUrl) {
            console.log("[Eyeglasses PDP] No variant image URL provided");
            return;
        }
        const thumbnails = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
        if (!thumbnails.length) {
            console.log("[Eyeglasses PDP] No thumbnails found");
            return;
        }
        console.log("[Eyeglasses PDP] Looking for thumbnail matching:", imageUrl);
        console.log("[Eyeglasses PDP] Available thumbnails:", thumbnails.length);
        let matchFound = false;
        thumbnails.forEach((thumbnail, index) => {
            const thumbUrl = thumbnail.getAttribute("data-image-url");
            console.log(`[Eyeglasses PDP] Thumbnail ${index + 1} URL:`, thumbUrl);
            if (thumbUrl === imageUrl) {
                thumbnails.forEach(t => t.classList.remove("active"));
                thumbnail.classList.add("active");
                matchFound = true;
                console.log("[Eyeglasses PDP] Exact match found at thumbnail", index + 1);
            }
        });
        if (!matchFound) {
            const imageFilename = imageUrl.split("/").pop().split("?")[0];
            console.log("[Eyeglasses PDP] Trying filename match:", imageFilename);
            thumbnails.forEach((thumbnail, index) => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0] : "";
                if (thumbFilename && thumbFilename === imageFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                    console.log("[Eyeglasses PDP] Filename match found at thumbnail", index + 1);
                }
            });
        }
        if (!matchFound) {
            const coreFilename = imageUrl.split("/").pop().split("?")[0].replace(/_\d+x\d*|\d+x\d*/g, "");
            console.log("[Eyeglasses PDP] Trying partial filename match:", coreFilename);
            thumbnails.forEach((thumbnail, index) => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbCoreFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0].replace(/_\d+x\d*|\d+x\d*/g, "") : "";
                if (thumbCoreFilename && thumbCoreFilename === coreFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                    console.log("[Eyeglasses PDP] Partial filename match found at thumbnail", index + 1);
                }
            });
        }
        if (!matchFound) {
            console.log("[Eyeglasses PDP] No matching thumbnail found - keeping current selection");
        }
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) {
            variantIdInput.value = variant.id;
        }
        const installmentsBanner = document.querySelector("shopify-payment-terms");
        if (installmentsBanner && variant.id) {
            installmentsBanner.setAttribute("variant-id", variant.id);
        }
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".eyeglasses-pdp-main__price");
            const compareAtElement = priceContainer?.querySelector(".eyeglasses-pdp-main__price-compare");
            const saleBadge = priceContainer?.querySelector(".eyeglasses-pdp-main__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareAtElement) {
                    compareAtElement.textContent = formatMoney(variant.compareAtPrice);
                    compareAtElement.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("eyeglasses-pdp-main__price-sale");
                priceElement.classList.remove("eyeglasses-pdp-main__price-regular");
            } else {
                if (compareAtElement) compareAtElement.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("eyeglasses-pdp-main__price-sale");
                priceElement.classList.add("eyeglasses-pdp-main__price-regular");
            }
        }
        if (stockStatusElement) {
            if (variant.available) {
                stockStatusElement.innerHTML = '<span class="eyeglasses-pdp-main__stock-in">In Stock</span>';
            } else {
                stockStatusElement.innerHTML = '<span class="eyeglasses-pdp-main__stock-out">Out of Stock</span>';
            }
        }
        const addToCartTrigger = document.getElementById("addToCartDropdownTrigger");
        if (addToCartTrigger) {
            if (variant.available) {
                addToCartTrigger.disabled = false;
                const triggerSpan = addToCartTrigger.querySelector("span");
                if (triggerSpan) triggerSpan.textContent = "Select Lenses";
            } else {
                addToCartTrigger.disabled = true;
                const triggerSpan = addToCartTrigger.querySelector("span");
                if (triggerSpan) triggerSpan.textContent = "Sold Out";
            }
        }
        const frameOnlyPrice = document.querySelector('[data-add-option="frame-only"] .dropdown-option__price');
        if (frameOnlyPrice) {
            frameOnlyPrice.textContent = formatMoney(variant.price);
        }
        if (variant.image) {
            updateMainImage(variant.image);
            updateThumbnailSelection(variant.image);
        } else if (variantData && variantData.featuredImage) {
            updateMainImage(variantData.featuredImage);
            updateThumbnailSelection(variantData.featuredImage);
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", newUrl.toString());
        const customizeBtn = document.getElementById("customizeClipsBtn");
        if (customizeBtn) {
            const baseHref = customizeBtn.dataset.baseHref;
            if (baseHref) {
                const variantTitle = encodeURIComponent(variant.title);
                const newUrl = new URL(`${baseHref}&variant=${variant.id}&variantTitle=${variantTitle}`, window.location.origin);
                const currentUrl = new URL(customizeBtn.href, window.location.origin);
                if (currentUrl.searchParams.get("source") === "order-flow") {
                    newUrl.searchParams.set("source", "order-flow");
                    newUrl.searchParams.set("return", "true");
                }
                customizeBtn.href = newUrl.toString();
                console.log("[Eyeglasses PDP] Updated customize button URL with variant:", variant.id, variant.title);
            }
        }
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
        console.log("[Eyeglasses PDP] Variant updated:", variant.title, "ID:", variant.id);
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (variantId) {
            const variant = variantData.variants.find(v => v.id === parseInt(variantId));
            if (variant) {
                variant.options.forEach((optionValue, index) => {
                    const input = document.querySelector(`.eyeglasses-pdp-main__option-input[name="options[${variantData.options[index]}]"][value="${optionValue}"]`);
                    if (input) {
                        input.checked = true;
                    }
                });
                updateVariantUI(variant);
            }
        }
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const selectedOptions = getSelectedOptions();
                const variant = findVariantByOptions(selectedOptions);
                const optionGroup = input.closest(".eyeglasses-pdp-main__option");
                if (optionGroup) {
                    const colorLabel = optionGroup.querySelector(".eyeglasses-pdp-main__selected-color");
                    if (colorLabel) {
                        colorLabel.textContent = input.value;
                    }
                }
                if (variant) {
                    updateVariantUI(variant);
                } else {
                    console.warn("[Eyeglasses PDP] No matching variant found for options:", selectedOptions);
                }
            });
        });
        initVariantFromURL();
    }
    const productForm = document.getElementById("productForm");
    if (productForm) {
        productForm.addEventListener("submit", async e => {
            e.preventDefault();
            const formData = new FormData(productForm);
            const variantId = formData.get("id");
            const quantity = parseInt(formData.get("quantity")) || 1;
            const submitButton = productForm.querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.disabled = true;
                const originalText = submitButton.textContent;
                submitButton.textContent = "Adding...";
                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json"
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: quantity,
                            sections: "cart-drawer-items,cart-header-dropdown"
                        })
                    });
                    if (!response.ok) {
                        throw new Error("Failed to add item to cart");
                    }
                    const data = await response.json();
                    console.log("Item added to cart:", data);
                    if (window.cartDrawer && data.sections) {
                        window.cartDrawer.updateCartSections(data.sections);
                    }
                    document.dispatchEvent(new CustomEvent("cart:item:added", {
                        detail: {
                            item: data.items ? data.items[0] : data,
                            sections: data.sections
                        }
                    }));
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                } catch (error) {
                    console.error("Error adding to cart:", error);
                    alert("Sorry, there was an error adding this item to your cart. Please try again.");
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            }
        });
    }
    const customizeBtn = document.getElementById("customizeClipsBtn");
    const customizeBtnText = document.getElementById("customizeBtnText");
    if (customizeBtn && customizeBtnText) {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        const variant = urlParams.get("variant");
        console.log("[Eyeglasses PDP] Current URL:", window.location.href);
        console.log("[Eyeglasses PDP] URL Parameters:", {
            source: source,
            variant: variant,
            allParams: Object.fromEntries(urlParams.entries())
        });
        if (source === "order-flow" && variant === "new-frame-lenses") {
            console.log("[Eyeglasses PDP] SUCCESS: Variant C detected - applying UI changes");
            customizeBtn.style.display = "";
            const dropdownContainer = document.getElementById("addToCartDropdownContainer");
            if (dropdownContainer) {
                dropdownContainer.style.display = "none";
                console.log("[Eyeglasses PDP] Dropdown container hidden");
            }
            customizeBtnText.textContent = "Select This Frame";
            customizeBtn.classList.remove("eyeglasses-pdp-main__cta--secondary");
            customizeBtn.classList.add("eyeglasses-pdp-main__cta--primary");
            const currentHref = customizeBtn.getAttribute("href");
            const hrefUrl = new URL(currentHref, window.location.origin);
            hrefUrl.searchParams.set("source", "order-flow");
            hrefUrl.searchParams.set("return", "true");
            customizeBtn.setAttribute("href", hrefUrl.toString());
            console.log("[Eyeglasses PDP] Variant C UI changes applied:", {
                buttonText: "Select This Frame",
                buttonClass: "primary",
                dropdownHidden: true,
                href: customizeBtn.getAttribute("href"),
                sourceParam: "order-flow (replaced from eyeglasses-pdp)"
            });
        } else {
            console.log("[Eyeglasses PDP] INFO: Not from Variant C - keeping default UI");
        }
    } else {
        console.log("[Eyeglasses PDP] WARNING: Button elements not found:", {
            customizeBtn: !!customizeBtn,
            customizeBtnText: !!customizeBtnText
        });
    }
    const enlargeBtn = document.getElementById("enlargeImageBtn");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImageA = document.getElementById("zoomImageA");
    const zoomImageB = document.getElementById("zoomImageB");
    const zoomOverlay = document.querySelector(".eyeglasses-pdp-main__zoom-overlay");
    const zoomCloseBtn = document.querySelector(".eyeglasses-pdp-main__zoom-close");
    const zoomPrevBtn = document.getElementById("zoomPrevBtn");
    const zoomNextBtn = document.getElementById("zoomNextBtn");
    if (enlargeBtn && zoomModal && zoomImageA && zoomImageB) {
        let zoomImageUrls = [];
        let currentZoomIndex = 0;
        let activeLayer = "A";
        const buildImageArray = () => {
            zoomImageUrls = [];
            const thumbs = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
            if (thumbs.length > 0) {
                thumbs.forEach(thumb => {
                    const url = thumb.getAttribute("data-image-url");
                    if (url) zoomImageUrls.push(url);
                });
            } else {
                if (mainImage && mainImage.src) {
                    zoomImageUrls.push(mainImage.src);
                }
            }
            if (zoomImageUrls.length <= 1) {
                if (zoomPrevBtn) zoomPrevBtn.classList.add("hidden");
                if (zoomNextBtn) zoomNextBtn.classList.add("hidden");
            } else {
                if (zoomPrevBtn) zoomPrevBtn.classList.remove("hidden");
                if (zoomNextBtn) zoomNextBtn.classList.remove("hidden");
            }
        };
        const findCurrentImageIndex = () => {
            const currentSrc = mainImage.src;
            const index = zoomImageUrls.findIndex(url => {
                const urlFilename = url.split("/").pop().split("?")[0];
                const currentFilename = currentSrc.split("/").pop().split("?")[0];
                return urlFilename === currentFilename || url === currentSrc;
            });
            return index >= 0 ? index : 0;
        };
        let isNavigating = false;
        const navigateToImage = index => {
            if (index < 0 || index >= zoomImageUrls.length) return;
            if (isNavigating) return;
            isNavigating = true;
            currentZoomIndex = index;
            const newUrl = zoomImageUrls[index];
            const currentImg = activeLayer === "A" ? zoomImageA : zoomImageB;
            const nextImg = activeLayer === "A" ? zoomImageB : zoomImageA;
            nextImg.src = newUrl;
            const performCrossfade = () => {
                if (typeof gsap !== "undefined") {
                    gsap.set(nextImg, {
                        zIndex: 2
                    });
                    gsap.set(currentImg, {
                        zIndex: 1
                    });
                    gsap.to(nextImg, {
                        opacity: 1,
                        duration: .3,
                        ease: "power2.out",
                        onComplete: () => {
                            gsap.set(currentImg, {
                                opacity: 0,
                                zIndex: 1
                            });
                            gsap.set(nextImg, {
                                zIndex: 1
                            });
                            activeLayer = activeLayer === "A" ? "B" : "A";
                            if (activeLayer === "A") {
                                zoomImageA.classList.add("eyeglasses-pdp-main__zoom-image--active");
                                zoomImageB.classList.remove("eyeglasses-pdp-main__zoom-image--active");
                            } else {
                                zoomImageB.classList.add("eyeglasses-pdp-main__zoom-image--active");
                                zoomImageA.classList.remove("eyeglasses-pdp-main__zoom-image--active");
                            }
                            isNavigating = false;
                        }
                    });
                } else {
                    nextImg.style.opacity = "1";
                    currentImg.style.opacity = "0";
                    activeLayer = activeLayer === "A" ? "B" : "A";
                    isNavigating = false;
                }
                if (mainImage) {
                    mainImage.src = newUrl;
                }
                updateThumbnailSelection(newUrl);
            };
            if (nextImg.decode) {
                nextImg.decode().then(performCrossfade).catch(() => {
                    performCrossfade();
                });
            } else {
                nextImg.onload = performCrossfade;
                nextImg.onerror = () => {
                    isNavigating = false;
                    console.warn("Failed to load image:", newUrl);
                };
            }
        };
        const goToPrevImage = () => {
            let newIndex = currentZoomIndex - 1;
            if (newIndex < 0) newIndex = zoomImageUrls.length - 1;
            navigateToImage(newIndex);
        };
        const goToNextImage = () => {
            let newIndex = currentZoomIndex + 1;
            if (newIndex >= zoomImageUrls.length) newIndex = 0;
            navigateToImage(newIndex);
        };
        const openModal = () => {
            buildImageArray();
            currentZoomIndex = findCurrentImageIndex();
            const currentImageSrc = mainImage.src;
            activeLayer = "A";
            zoomImageA.src = currentImageSrc;
            zoomImageB.src = "";
            gsap.set(zoomImageA, {
                opacity: 1
            });
            gsap.set(zoomImageB, {
                opacity: 0
            });
            zoomImageA.classList.add("eyeglasses-pdp-main__zoom-image--active");
            zoomImageB.classList.remove("eyeglasses-pdp-main__zoom-image--active");
            gsap.set(zoomModal, {
                display: "flex"
            });
            gsap.fromTo(zoomModal, {
                opacity: 0
            }, {
                opacity: 1,
                duration: .3,
                ease: "power2.out"
            });
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            gsap.to(zoomModal, {
                opacity: 0,
                duration: .3,
                ease: "power2.in",
                onComplete: () => {
                    gsap.set(zoomModal, {
                        display: "none"
                    });
                    zoomImageA.src = "";
                    zoomImageB.src = "";
                }
            });
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        if (zoomPrevBtn) {
            zoomPrevBtn.addEventListener("click", e => {
                e.stopPropagation();
                goToPrevImage();
            });
        }
        if (zoomNextBtn) {
            zoomNextBtn.addEventListener("click", e => {
                e.stopPropagation();
                goToNextImage();
            });
        }
        if (zoomCloseBtn) {
            zoomCloseBtn.addEventListener("click", closeModal);
        }
        if (zoomOverlay) {
            zoomOverlay.addEventListener("click", closeModal);
        }
        document.addEventListener("keydown", e => {
            if (zoomModal.style.display !== "flex") return;
            switch (e.key) {
              case "Escape":
                closeModal();
                break;

              case "ArrowLeft":
                e.preventDefault();
                goToPrevImage();
                break;

              case "ArrowRight":
                e.preventDefault();
                goToNextImage();
                break;
            }
        });
    }
    const dropdownContainer = document.getElementById("addToCartDropdownContainer");
    const dropdownTrigger = document.getElementById("addToCartDropdownTrigger");
    const dropdownMenu = document.getElementById("addToCartDropdownMenu");
    if (dropdownContainer && dropdownTrigger && dropdownMenu) {
        dropdownTrigger.addEventListener("click", function(e) {
            e.preventDefault();
            const isOpen = dropdownContainer.classList.contains("open");
            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });
        function openDropdown() {
            dropdownContainer.classList.add("open");
            dropdownTrigger.setAttribute("aria-expanded", "true");
            dropdownMenu.setAttribute("aria-hidden", "false");
        }
        function closeDropdown() {
            dropdownContainer.classList.remove("open");
            dropdownTrigger.setAttribute("aria-expanded", "false");
            dropdownMenu.setAttribute("aria-hidden", "true");
        }
        document.addEventListener("click", function(e) {
            if (!dropdownContainer.contains(e.target)) {
                closeDropdown();
            }
        });
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                closeDropdown();
            }
        });
        const options = dropdownMenu.querySelectorAll(".eyeglasses-pdp-main__dropdown-option");
        options.forEach(function(option) {
            option.addEventListener("click", function() {
                const addOption = this.dataset.addOption;
                closeDropdown();
                handleAddOption(addOption);
            });
        });
        function handleAddOption(option) {
            const productHandle = dropdownContainer.dataset.productHandle;
            const variantIdInput = document.getElementById("productVariantId");
            const variantId = variantIdInput ? variantIdInput.value : "";
            let variantTitle = "";
            if (variantData && variantId) {
                const selectedVariant = variantData.variants.find(v => v.id === parseInt(variantId));
                if (selectedVariant) {
                    variantTitle = encodeURIComponent(selectedVariant.title);
                }
            }
            switch (option) {
              case "frame-only":
                addFrameToCart();
                break;

              case "prescription-only":
                window.location.href = `/pages/order-flow?start=step2&frame=${productHandle}&variant=${variantId}&variantTitle=${variantTitle}&source=eyeglasses-pdp&mode=prescription-only`;
                break;

              case "full-customize":
                window.location.href = `/pages/order-flow?start=step2&frame=${productHandle}&variant=${variantId}&variantTitle=${variantTitle}&source=eyeglasses-pdp`;
                break;
            }
        }
        async function addFrameToCart() {
            const productForm = document.getElementById("productForm");
            if (!productForm) return;
            const formData = new FormData(productForm);
            const variantId = formData.get("id");
            const quantity = parseInt(formData.get("quantity")) || 1;
            dropdownTrigger.disabled = true;
            const triggerSpan = dropdownTrigger.querySelector("span");
            const originalText = triggerSpan.textContent;
            triggerSpan.textContent = "Adding...";
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity,
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) {
                    throw new Error("Failed to add item to cart");
                }
                const data = await response.json();
                if (window.cartDrawer && window.cartDrawer.updateCartSections) {
                    window.cartDrawer.updateCartSections(data.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: data
                }));
                dropdownTrigger.disabled = false;
                triggerSpan.textContent = originalText;
            } catch (error) {
                console.error("Error adding to cart:", error);
                alert("Sorry, there was an error adding this item to your cart. Please try again.");
                dropdownTrigger.disabled = false;
                triggerSpan.textContent = originalText;
            }
        }
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-pdp-seo"]) return;
  try {
    (function() {
    var WORD_LIMIT = 150;
    var MORE_RE = /<!--\s*more\s*-->/i;
    function setToggleText(toggleBtn, expanded) {
        var toggleText = toggleBtn.querySelector("[data-seo-toggle-text]");
        if (toggleText) {
            toggleText.textContent = expanded ? toggleBtn.dataset.lessText : toggleBtn.dataset.moreText;
        }
    }
    function initSeoExpand() {
        var sections = document.querySelectorAll("[data-seo-expandable]");
        sections.forEach(function(wrapper) {
            if (wrapper.dataset.seoInitialized) return;
            wrapper.dataset.seoInitialized = "true";
            var contentEl = wrapper.querySelector("[data-seo-content]");
            var card = wrapper.closest(".eg-pdp-seo__card, .eg-plp-seo__card");
            var toggleBtn = card ? card.querySelector("[data-seo-toggle]") : null;
            if (!contentEl || !toggleBtn) return;
            if (!toggleBtn.dataset.moreText) {
                toggleBtn.dataset.moreText = toggleBtn.querySelector("[data-seo-toggle-text]").textContent;
            }
            if (!toggleBtn.dataset.lessText) {
                toggleBtn.dataset.lessText = "Read less";
            }
            var html = contentEl.innerHTML;
            if (MORE_RE.test(html)) {
                var parts = html.split(MORE_RE);
                var before = parts[0];
                var after = parts.slice(1).join("");
                contentEl.innerHTML = before + "<div data-seo-extra hidden>" + after + "</div>";
                var extraEl = contentEl.querySelector("[data-seo-extra]");
                toggleBtn.hidden = false;
                toggleBtn.addEventListener("click", function() {
                    var isHidden = extraEl.hasAttribute("hidden");
                    if (isHidden) {
                        extraEl.removeAttribute("hidden");
                    } else {
                        extraEl.setAttribute("hidden", "");
                    }
                    toggleBtn.setAttribute("aria-expanded", String(isHidden));
                    setToggleText(toggleBtn, isHidden);
                });
                return;
            }
            var text = contentEl.textContent || "";
            var wordCount = text.trim().split(/\s+/).filter(Boolean).length;
            if (wordCount <= WORD_LIMIT) return;
            wrapper.setAttribute("data-collapsed", "true");
            toggleBtn.hidden = false;
            toggleBtn.addEventListener("click", function() {
                var isCollapsed = wrapper.getAttribute("data-collapsed") === "true";
                wrapper.setAttribute("data-collapsed", String(!isCollapsed));
                toggleBtn.setAttribute("aria-expanded", String(isCollapsed));
                setToggleText(toggleBtn, isCollapsed);
            });
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initSeoExpand);
    } else {
        initSeoExpand();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-plp-seo"]) return;
  try {
    (function() {
    var WORD_LIMIT = 150;
    var MORE_RE = /<!--\s*more\s*-->/i;
    function setToggleText(toggleBtn, expanded) {
        var toggleText = toggleBtn.querySelector("[data-seo-toggle-text]");
        if (toggleText) {
            toggleText.textContent = expanded ? toggleBtn.dataset.lessText : toggleBtn.dataset.moreText;
        }
    }
    function initSeoExpand() {
        var sections = document.querySelectorAll("[data-seo-expandable]");
        sections.forEach(function(wrapper) {
            if (wrapper.dataset.seoInitialized) return;
            wrapper.dataset.seoInitialized = "true";
            var contentEl = wrapper.querySelector("[data-seo-content]");
            var card = wrapper.closest(".eg-pdp-seo__card, .eg-plp-seo__card");
            var toggleBtn = card ? card.querySelector("[data-seo-toggle]") : null;
            if (!contentEl || !toggleBtn) return;
            if (!toggleBtn.dataset.moreText) {
                toggleBtn.dataset.moreText = toggleBtn.querySelector("[data-seo-toggle-text]").textContent;
            }
            if (!toggleBtn.dataset.lessText) {
                toggleBtn.dataset.lessText = "Read less";
            }
            var html = contentEl.innerHTML;
            if (MORE_RE.test(html)) {
                var parts = html.split(MORE_RE);
                var before = parts[0];
                var after = parts.slice(1).join("");
                contentEl.innerHTML = before + "<div data-seo-extra hidden>" + after + "</div>";
                var extraEl = contentEl.querySelector("[data-seo-extra]");
                toggleBtn.hidden = false;
                toggleBtn.addEventListener("click", function() {
                    var isHidden = extraEl.hasAttribute("hidden");
                    if (isHidden) {
                        extraEl.removeAttribute("hidden");
                    } else {
                        extraEl.setAttribute("hidden", "");
                    }
                    toggleBtn.setAttribute("aria-expanded", String(isHidden));
                    setToggleText(toggleBtn, isHidden);
                });
                return;
            }
            var text = contentEl.textContent || "";
            var wordCount = text.trim().split(/\s+/).filter(Boolean).length;
            if (wordCount <= WORD_LIMIT) return;
            wrapper.setAttribute("data-collapsed", "true");
            toggleBtn.hidden = false;
            toggleBtn.addEventListener("click", function() {
                var isCollapsed = wrapper.getAttribute("data-collapsed") === "true";
                wrapper.setAttribute("data-collapsed", String(!isCollapsed));
                toggleBtn.setAttribute("aria-expanded", String(isCollapsed));
                setToggleText(toggleBtn, isCollapsed);
            });
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initSeoExpand);
    } else {
        initSeoExpand();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-product-grid"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const sortSelect = document.getElementById("SortBy");
    if (sortSelect) {
        sortSelect.addEventListener("change", function() {
            const sortValue = this.value;
            const url = new URL(window.location.href);
            url.searchParams.set("sort_by", sortValue);
            window.location.href = url.toString();
        });
        const urlParams = new URLSearchParams(window.location.search);
        const currentSort = urlParams.get("sort_by");
        if (currentSort) {
            sortSelect.value = currentSort;
        }
    }
    const gridArea = document.querySelector(".eyeglasses-plp-grid-area");
    const sidebar = document.querySelector(".eyeglasses-filter-sidebar");
    if (gridArea && sidebar) {
        const stickyObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const gridRect = gridArea.getBoundingClientRect();
                const sidebarHeight = sidebar.offsetHeight;
                if (gridRect.bottom < sidebarHeight + 120) {
                    sidebar.classList.add("sidebar--unstuck");
                } else {
                    sidebar.classList.remove("sidebar--unstuck");
                }
            });
        }, {
            threshold: [ 0, .1, .5, .9, 1 ],
            rootMargin: "0px"
        });
        stickyObserver.observe(gridArea);
        let scrollTimeout;
        window.addEventListener("scroll", () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const gridRect = gridArea.getBoundingClientRect();
                const sidebarHeight = sidebar.offsetHeight;
                if (gridRect.bottom < sidebarHeight + 120) {
                    sidebar.classList.add("sidebar--unstuck");
                } else {
                    sidebar.classList.remove("sidebar--unstuck");
                }
            }, 10);
        }, {
            passive: true
        });
    }
    const urlParams = new URLSearchParams(window.location.search);
    const orderFlow = urlParams.get("order_flow");
    const variant = urlParams.get("variant");
    console.log("[Eyeglasses Collection] Current URL:", window.location.href);
    console.log("[Eyeglasses Collection] URL Parameters:", {
        orderFlow: orderFlow,
        variant: variant,
        allParams: Object.fromEntries(urlParams.entries())
    });
    if (orderFlow === "true" && variant === "new-frame-lenses") {
        console.log("[Eyeglasses Collection] SUCCESS: Variant C detected - appending parameters to product links");
        const productLinks = document.querySelectorAll(".product-card__image-link, .product-card__title a");
        productLinks.forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set("source", "order-flow");
            url.searchParams.set("variant", "new-frame-lenses");
            link.href = url.toString();
            console.log("[Eyeglasses Collection] Updated link:", link.href);
        });
    } else {
        console.log("[Eyeglasses Collection] INFO: Not from Variant C - keeping default product links");
    }
    (function initColorSwatches() {
        const productCards = document.querySelectorAll(".product-card");
        productCards.forEach(card => {
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            const mainImage = card.querySelector(".product-card__image");
            const hoverImage = card.querySelector(".product-card__image-hover");
            const crossfadeImage = card.querySelector(".product-card__image-crossfade");
            const variantDataScript = card.querySelector(".product-card__variant-data");
            if (!swatches.length || !mainImage || !crossfadeImage) return;
            let variantData = null;
            if (variantDataScript) {
                try {
                    variantData = JSON.parse(variantDataScript.textContent);
                } catch (e) {
                    console.error("[PLP Swatches] Failed to parse variant data:", e);
                }
            }
            let isTransitioning = false;
            swatches.forEach(swatch => {
                swatch.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (isTransitioning) {
                        console.log("[PLP Swatches] Transition in progress, ignoring click");
                        return;
                    }
                    const colorName = this.dataset.color;
                    let imageUrl = null;
                    if (variantData && variantData.variants) {
                        const matchingVariant = variantData.variants.find(v => v.options && v.options.some(opt => opt === colorName));
                        if (matchingVariant && matchingVariant.image) {
                            imageUrl = matchingVariant.image;
                        } else {
                            imageUrl = variantData.featuredImage;
                        }
                    }
                    if (!imageUrl) {
                        console.log("[PLP Swatches] No image found for color:", colorName);
                        return;
                    }
                    if (mainImage.src === imageUrl || crossfadeImage.src === imageUrl) {
                        swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                        this.classList.add("product-card__color-swatch--active");
                        return;
                    }
                    isTransitioning = true;
                    swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                    this.classList.add("product-card__color-swatch--active");
                    card.classList.add("product-card--swatch-active");
                    crossfadeImage.src = imageUrl;
                    const performCrossfade = () => {
                        crossfadeImage.classList.add("is-visible");
                        setTimeout(() => {
                            mainImage.src = imageUrl;
                            mainImage.removeAttribute("srcset");
                            if (hoverImage) {
                                hoverImage.src = imageUrl;
                            }
                            requestAnimationFrame(() => {
                                crossfadeImage.classList.remove("is-visible");
                                setTimeout(() => {
                                    card.classList.remove("product-card--swatch-active");
                                    isTransitioning = false;
                                }, 50);
                            });
                        }, 320);
                    };
                    if (typeof crossfadeImage.decode === "function") {
                        crossfadeImage.decode().then(performCrossfade).catch(() => {
                            console.warn("[PLP Swatches] Image decode failed, using fallback");
                            performCrossfade();
                        });
                    } else {
                        const checkLoaded = () => {
                            if (crossfadeImage.complete && crossfadeImage.naturalWidth > 0) {
                                performCrossfade();
                            } else {
                                crossfadeImage.onload = performCrossfade;
                                crossfadeImage.onerror = () => {
                                    console.error("[PLP Swatches] Image load failed");
                                    isTransitioning = false;
                                    card.classList.remove("product-card--swatch-active");
                                };
                            }
                        };
                        checkLoaded();
                    }
                    console.log("[PLP Swatches] Crossfade initiated for color:", colorName);
                });
            });
        });
        console.log("[PLP Swatches] Initialized with crossfade for", productCards.length, "cards");
    })();
    window.updateProductImagesByColorFilter = function(selectedColorFamily) {
        if (!selectedColorFamily) {
            console.log("[Color Filter Sync] No color selected, skipping image update");
            return;
        }
        const normalizedColor = selectedColorFamily.toLowerCase().trim();
        console.log("[Color Filter Sync] Updating images for color family:", normalizedColor);
        const productCards = document.querySelectorAll(".product-card:not(.filter-hidden)");
        let updatedCount = 0;
        productCards.forEach(card => {
            const variantDataScript = card.querySelector(".product-card__variant-data");
            const mainImage = card.querySelector(".product-card__image");
            const crossfadeImage = card.querySelector(".product-card__image-crossfade");
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            if (!variantDataScript || !mainImage) return;
            let variantData = null;
            try {
                variantData = JSON.parse(variantDataScript.textContent);
            } catch (e) {
                console.error("[Color Filter Sync] Failed to parse variant data:", e);
                return;
            }
            if (!variantData || !variantData.variants) return;
            const matchingVariant = variantData.variants.find(v => v.colorFamily && v.colorFamily.some(cf => cf === normalizedColor));
            if (!matchingVariant) {
                return;
            }
            const imageUrl = matchingVariant.image || variantData.featuredImage;
            if (!imageUrl) return;
            if (mainImage.src === imageUrl) {
                updateSwatchState();
                return;
            }
            function updateSwatchState() {
                if (!swatches.length) return;
                swatches.forEach(swatch => {
                    const swatchColor = swatch.dataset.color;
                    const isMatch = matchingVariant.options && matchingVariant.options.some(opt => opt === swatchColor);
                    if (isMatch) {
                        swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                        swatch.classList.add("product-card__color-swatch--active");
                    }
                });
            }
            if (crossfadeImage) {
                card.classList.add("product-card--swatch-active");
                crossfadeImage.src = imageUrl;
                const performCrossfade = () => {
                    crossfadeImage.classList.add("is-visible");
                    setTimeout(() => {
                        mainImage.src = imageUrl;
                        mainImage.removeAttribute("srcset");
                        const hoverImage = card.querySelector(".product-card__image-hover");
                        if (hoverImage) {
                            hoverImage.src = imageUrl;
                        }
                        requestAnimationFrame(() => {
                            crossfadeImage.classList.remove("is-visible");
                            setTimeout(() => {
                                card.classList.remove("product-card--swatch-active");
                            }, 50);
                        });
                    }, 320);
                };
                if (typeof crossfadeImage.decode === "function") {
                    crossfadeImage.decode().then(performCrossfade).catch(performCrossfade);
                } else {
                    if (crossfadeImage.complete) {
                        performCrossfade();
                    } else {
                        crossfadeImage.onload = performCrossfade;
                    }
                }
            } else {
                mainImage.src = imageUrl;
                mainImage.removeAttribute("srcset");
            }
            updateSwatchState();
            updatedCount++;
        });
        console.log("[Color Filter Sync] Updated", updatedCount, "product cards for color:", normalizedColor);
    };
    window.resetProductImagesToDefault = function() {
        console.log("[Color Filter Sync] Resetting images to default");
        const productCards = document.querySelectorAll(".product-card");
        productCards.forEach(card => {
            const variantDataScript = card.querySelector(".product-card__variant-data");
            const mainImage = card.querySelector(".product-card__image");
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            if (!variantDataScript || !mainImage) return;
            let variantData = null;
            try {
                variantData = JSON.parse(variantDataScript.textContent);
            } catch (e) {
                return;
            }
            if (variantData && variantData.featuredImage) {
                mainImage.src = variantData.featuredImage;
                mainImage.removeAttribute("srcset");
            }
            if (swatches.length) {
                swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                swatches[0].classList.add("product-card__color-swatch--active");
            }
        });
    };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-products-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    function init() {
        const carousels = document.querySelectorAll(".eyeglasses-carousel");
        carousels.forEach(function(carousel) {
            const source = carousel.dataset.source;
            if (source === "recommendations") {
                loadRecommendations(carousel);
            }
            initCarouselNavigation(carousel);
            animateCardsEntrance(carousel);
        });
    }
    function loadRecommendations(carousel) {
        const recommendationsContainer = carousel.querySelector(".eyeglasses-carousel__recommendations");
        if (!recommendationsContainer) return;
        const url = recommendationsContainer.dataset.url;
        if (!url) return;
        var observer = new IntersectionObserver(function(entries, obs) {
            if (!entries[0].isIntersecting) return;
            obs.unobserve(recommendationsContainer);
            fetch(url).then(function(response) {
                return response.text();
            }).then(function(text) {
                var html = document.createElement("div");
                html.innerHTML = text;
                var newRecommendations = html.querySelector(".eyeglasses-carousel__recommendations");
                if (newRecommendations && newRecommendations.innerHTML.trim().length) {
                    recommendationsContainer.innerHTML = newRecommendations.innerHTML;
                    initCarouselNavigation(carousel);
                    animateCardsEntrance(carousel);
                }
            }).catch(function(error) {
                console.error("Error loading recommendations:", error);
                recommendationsContainer.innerHTML = '<p class="eyeglasses-carousel__empty">Unable to load recommendations</p>';
            });
        }, {
            rootMargin: "200px 0px"
        });
        observer.observe(recommendationsContainer);
    }
    function initCarouselNavigation(carousel) {
        var track = carousel.querySelector(".eyeglasses-carousel__track");
        var prevBtn = carousel.querySelector(".eyeglasses-carousel__arrow--prev");
        var nextBtn = carousel.querySelector(".eyeglasses-carousel__arrow--next");
        function getCards() {
            return carousel.querySelectorAll(".product-card.eyeglasses-product-card");
        }
        var cards = getCards();
        console.log("[Carousel Debug] Initial card count:", cards.length);
        console.log("[Carousel Debug] Track exists:", !!track);
        console.log("[Carousel Debug] Prev button:", !!prevBtn);
        console.log("[Carousel Debug] Next button:", !!nextBtn);
        if (!track) {
            console.error("[Carousel] Track element not found");
            return;
        }
        var currentPosition = 0;
        var cardsPerView = getCardsPerView();
        function getCardsPerView() {
            var width = window.innerWidth;
            if (width > 1200) return 4;
            if (width > 1024) return 3;
            if (width > 480) return 2;
            return 1;
        }
        function updateTrackPosition() {
            var currentCards = getCards();
            if (currentCards.length === 0) return;
            var cardWidth = currentCards[0].offsetWidth;
            var gap = 24;
            var offset = -(currentPosition * (cardWidth + gap));
            if (typeof gsap !== "undefined") {
                gsap.to(track, {
                    x: offset,
                    duration: .6,
                    ease: "power2.inOut"
                });
            } else {
                track.style.transform = "translateX(" + offset + "px)";
            }
        }
        function updateButtonStates() {
            var currentCards = getCards();
            var totalCards = currentCards.length;
            var maxPosition = Math.max(0, totalCards - cardsPerView);
            console.log("[Carousel Debug] Button state update - Cards:", totalCards, "PerView:", cardsPerView, "MaxPos:", maxPosition, "CurrentPos:", currentPosition);
            if (prevBtn) {
                prevBtn.disabled = currentPosition === 0;
            }
            if (nextBtn) {
                var shouldDisableNext = currentPosition >= maxPosition;
                nextBtn.disabled = shouldDisableNext;
                console.log("[Carousel Debug] Next button disabled:", shouldDisableNext);
            }
        }
        function slidePrev() {
            if (currentPosition > 0) {
                currentPosition--;
                updateTrackPosition();
                updateButtonStates();
            }
        }
        function slideNext() {
            var currentCards = getCards();
            var maxPosition = Math.max(0, currentCards.length - cardsPerView);
            console.log("[Carousel Debug] slideNext - MaxPos:", maxPosition, "CurrentPos:", currentPosition);
            if (currentPosition < maxPosition) {
                currentPosition++;
                updateTrackPosition();
                updateButtonStates();
            }
        }
        function handleResize() {
            var newCardsPerView = getCardsPerView();
            if (newCardsPerView !== cardsPerView) {
                cardsPerView = newCardsPerView;
                var currentCards = getCards();
                var maxPosition = Math.max(0, currentCards.length - cardsPerView);
                if (currentPosition > maxPosition) {
                    currentPosition = maxPosition;
                    updateTrackPosition();
                }
                updateButtonStates();
            }
        }
        if (prevBtn) {
            prevBtn.replaceWith(prevBtn.cloneNode(true));
            prevBtn = carousel.querySelector(".eyeglasses-carousel__arrow--prev");
            prevBtn.addEventListener("click", slidePrev);
        }
        if (nextBtn) {
            nextBtn.replaceWith(nextBtn.cloneNode(true));
            nextBtn = carousel.querySelector(".eyeglasses-carousel__arrow--next");
            nextBtn.addEventListener("click", slideNext);
        }
        window.addEventListener("resize", handleResize);
        requestAnimationFrame(function() {
            updateButtonStates();
        });
    }
    function animateCardsEntrance(carousel) {
        var cards = carousel.querySelectorAll(".product-card.eyeglasses-product-card");
        if (typeof gsap !== "undefined" && cards.length > 0) {
            gsap.fromTo(cards, {
                y: 20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                duration: .5,
                stagger: .1,
                ease: "power2.out",
                delay: .2
            });
        } else {
            cards.forEach(function(card) {
                card.style.opacity = "1";
                card.style.transform = "translateY(0)";
            });
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
    window.EyeglassesCarousel = {
        init: init
    };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    (function() {
    function bindAccordion(root) {
        var questions = root.querySelectorAll(".faq-accordion__question");
        questions.forEach(function(question) {
            if (question.dataset.faqBound === "true") {
                return;
            }
            question.dataset.faqBound = "true";
            question.addEventListener("click", function() {
                var isExpanded = this.getAttribute("aria-expanded") === "true";
                var answer = document.getElementById(this.getAttribute("aria-controls"));
                var list = this.closest(".faq-accordion__list");
                if (list) {
                    list.querySelectorAll(".faq-accordion__question").forEach(function(other) {
                        if (other !== question) {
                            other.setAttribute("aria-expanded", "false");
                            var otherAnswer = document.getElementById(other.getAttribute("aria-controls"));
                            if (otherAnswer) {
                                otherAnswer.setAttribute("aria-hidden", "true");
                            }
                        }
                    });
                }
                this.setAttribute("aria-expanded", String(!isExpanded));
                if (answer) {
                    answer.setAttribute("aria-hidden", String(isExpanded));
                }
            });
        });
    }
    function bindAll() {
        document.querySelectorAll(".faq-accordion").forEach(bindAccordion);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindAll);
    } else {
        bindAll();
    }
    document.addEventListener("shopify:section:load", function(event) {
        if (event.target && event.target.querySelector) {
            var root = event.target.querySelector(".faq-accordion");
            if (root) {
                bindAccordion(root);
            }
        }
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById("faq-search");
    const topicChips = document.querySelectorAll(".faq__topic-chip");
    const categoryCards = document.querySelectorAll(".faq__category-card");
    const categorySections = document.querySelectorAll(".faq__category-section");
    let currentActiveCategory = "product-fit";
    console.log("FAQ Debug:", {
        searchInput: !!searchInput,
        categoryCards: categoryCards.length,
        categorySections: categorySections.length,
        topicChips: topicChips.length
    });
    function handleURLParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get("search");
        const categoryParam = urlParams.get("category");
        if (searchQuery && searchInput) {
            searchInput.value = decodeURIComponent(searchQuery);
            searchInput.dispatchEvent(new Event("input"));
            setTimeout(() => {
                const faqContent = document.querySelector(".faq__content");
                if (faqContent) {
                    scrollToElement(faqContent);
                }
            }, 300);
            console.log("FAQ: Applied search from URL:", searchQuery);
        }
        if (categoryParam && !searchQuery) {
            const targetCard = document.querySelector(`[data-category="${categoryParam}"]`);
            if (targetCard) {
                targetCard.click();
                console.log("FAQ: Activated category from URL:", categoryParam);
            }
        }
    }
    function scrollToElement(element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let headerOffset = 0;
        const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
        const announcementBar = document.querySelector(".announcement-bar");
        const regularHeader = document.querySelector(".chemistrie-header");
        if (stickyHeader || regularHeader) {
            headerOffset = announcementBar ? 120 : 84;
        }
        const targetPosition = rect.top + scrollTop - headerOffset - 20;
        window.scrollTo({
            top: Math.max(0, targetPosition),
            behavior: "smooth"
        });
    }
    if (searchInput) {
        searchInput.addEventListener("input", function() {
            const searchTerm = this.value.toLowerCase().trim();
            if (searchTerm === "") {
                restoreActiveCategory();
                return;
            }
            const searchWords = searchTerm.split(/\s+/).filter(word => word.length > 0);
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            let hasResults = false;
            categorySections.forEach(section => {
                const questions = section.querySelectorAll(".faq__item");
                let sectionHasResults = false;
                questions.forEach(question => {
                    const questionText = question.querySelector(".faq__question-text").textContent.toLowerCase();
                    const answerText = question.querySelector(".faq__answer-content").textContent.toLowerCase();
                    const combinedText = questionText + " " + answerText;
                    const hasMatch = searchWords.some(word => combinedText.includes(word));
                    if (hasMatch) {
                        question.style.display = "block";
                        sectionHasResults = true;
                        hasResults = true;
                    } else {
                        question.style.display = "none";
                    }
                });
                if (sectionHasResults) {
                    section.classList.add("faq__category-section--active");
                    section.style.display = "block";
                } else {
                    section.classList.remove("faq__category-section--active");
                    section.style.display = "none";
                }
            });
            console.log("Search results:", {
                searchWords: searchWords,
                hasResults: hasResults
            });
        });
    }
    function restoreActiveCategory() {
        categorySections.forEach(s => {
            s.classList.remove("faq__category-section--active");
            s.style.display = "none";
            const questions = s.querySelectorAll(".faq__item");
            questions.forEach(q => q.style.display = "block");
        });
        categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
        const activeCard = document.querySelector(`[data-category="${currentActiveCategory}"]`);
        const activeSection = document.querySelector(`.faq__category-section[data-category="${currentActiveCategory}"]`);
        if (activeCard && activeSection) {
            activeCard.classList.add("faq__category-card--active");
            activeSection.classList.add("faq__category-section--active");
            activeSection.style.display = "block";
        }
        console.log("Restored active category:", currentActiveCategory);
    }
    topicChips.forEach(chip => {
        chip.addEventListener("click", function() {
            if (searchInput) {
                searchInput.value = this.dataset.topic;
                searchInput.dispatchEvent(new Event("input"));
            }
        });
    });
    categoryCards.forEach(card => {
        card.addEventListener("click", function() {
            const category = this.getAttribute("data-category");
            console.log("Category card clicked:", category);
            currentActiveCategory = category;
            if (searchInput) {
                searchInput.value = "";
            }
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            categorySections.forEach(s => {
                s.classList.remove("faq__category-section--active");
                s.style.display = "none";
            });
            this.classList.add("faq__category-card--active");
            const targetSection = document.querySelector(`.faq__category-section[data-category="${category}"]`);
            console.log("Target section found:", !!targetSection);
            if (targetSection) {
                targetSection.classList.add("faq__category-section--active");
                targetSection.style.display = "block";
                const questions = targetSection.querySelectorAll(".faq__item");
                questions.forEach(q => q.style.display = "block");
                console.log("Questions in section:", questions.length);
            } else {
                console.error("Could not find section for category:", category);
            }
            const faqContent = document.querySelector(".faq__content");
            if (faqContent) {
                const rect = faqContent.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let headerOffset = 0;
                const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
                const announcementBar = document.querySelector(".announcement-bar");
                const regularHeader = document.querySelector(".chemistrie-header");
                if (stickyHeader || regularHeader) {
                    headerOffset = announcementBar ? 120 : 84;
                }
                const targetPosition = rect.top + scrollTop - headerOffset - 20;
                console.log("Scroll calculation:", {
                    headerOffset: headerOffset,
                    hasAnnouncement: !!announcementBar,
                    isSticky: !!stickyHeader,
                    targetPosition: targetPosition
                });
                window.scrollTo({
                    top: Math.max(0, targetPosition),
                    behavior: "smooth"
                });
            }
        });
    });
    const questions = document.querySelectorAll(".faq__question");
    questions.forEach(question => {
        question.addEventListener("click", function() {
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            const answer = this.nextElementSibling;
            this.setAttribute("aria-expanded", !isExpanded);
            answer.setAttribute("aria-hidden", isExpanded);
            const currentSection = this.closest(".faq__category-section");
            if (currentSection) {
                const otherQuestions = currentSection.querySelectorAll(".faq__question");
                otherQuestions.forEach(otherQuestion => {
                    if (otherQuestion !== this) {
                        otherQuestion.setAttribute("aria-expanded", "false");
                        otherQuestion.nextElementSibling.setAttribute("aria-hidden", "true");
                    }
                });
            }
        });
    });
    categoryCards.forEach((card, index) => {
        card.addEventListener("keydown", function(e) {
            if (e.key === "ArrowLeft" && index > 0) {
                categoryCards[index - 1].focus();
                categoryCards[index - 1].click();
            } else if (e.key === "ArrowRight" && index < categoryCards.length - 1) {
                categoryCards[index + 1].focus();
                categoryCards[index + 1].click();
            }
        });
    });
    window.openLiveChat = function() {
        alert("Live chat feature will be integrated with your chat service provider.");
        console.log("Opening live chat...");
    };
    function initializeFAQ() {
        console.log("Initializing FAQ with default category:", currentActiveCategory);
        const firstCard = document.querySelector('[data-category="product-fit"]');
        const firstSection = document.querySelector('.faq__category-section[data-category="product-fit"]');
        if (firstCard && firstSection) {
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            firstCard.classList.add("faq__category-card--active");
            categorySections.forEach(s => {
                s.classList.remove("faq__category-section--active");
                s.style.display = "none";
            });
            firstSection.classList.add("faq__category-section--active");
            firstSection.style.display = "block";
            const questions = firstSection.querySelectorAll(".faq__item");
            questions.forEach(q => q.style.display = "block");
            console.log("FAQ initialized successfully", {
                firstCard: !!firstCard,
                firstSection: !!firstSection,
                questionsCount: questions.length
            });
        } else {
            console.error("Could not initialize FAQ - missing elements", {
                firstCard: !!firstCard,
                firstSection: !!firstSection
            });
        }
    }
    setTimeout(() => {
        initializeFAQ();
        handleURLParameters();
    }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const footerLinks = document.querySelectorAll('.footer__link[href^="#"]');
    footerLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const thumbnails = document.querySelectorAll(".gift-card-pdp__thumbnail");
    const mainImage = document.getElementById("giftCardMainImage");
    const variantInputs = document.querySelectorAll(".gift-card-pdp__option-input");
    const variantDataElement = document.getElementById("giftCardVariantData");
    const variantIdInput = document.getElementById("giftCardVariantId");
    const priceElement = document.getElementById("giftCardPriceValue");
    const addToCartBtn = document.getElementById("giftCardAddToCartBtn");
    const productForm = document.getElementById("giftCardForm");
    const sendAsGiftCheckbox = document.getElementById("GiftSendAsGift");
    const recipientWrap = document.getElementById("giftRecipientWrap");
    const recipientEmailInput = document.getElementById("GiftRecipientEmail");
    const recipientEmailError = document.getElementById("giftRecipientEmailError");
    const messageTextarea = document.getElementById("GiftMessage");
    const messageCounter = document.getElementById("giftMessageCount");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("[Gift Card PDP] Failed to parse variant data:", e);
        }
    }
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl) {
                    fadeSwapImage(mainImage, newImageUrl);
                }
            });
        });
    }
    function fadeSwapImage(imgEl, newUrl) {
        if (!imgEl || !newUrl || imgEl.src === newUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(imgEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    imgEl.src = newUrl;
                    gsap.to(imgEl, {
                        opacity: 1,
                        duration: .3
                    });
                }
            });
        } else {
            imgEl.src = newUrl;
        }
    }
    function getSelectedOptions() {
        const options = [];
        document.querySelectorAll(".gift-card-pdp__option").forEach(group => {
            const checked = group.querySelector(".gift-card-pdp__option-input:checked");
            if (checked) options.push(checked.value);
        });
        return options;
    }
    function findVariantByOptions(selected) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(v => selected.every((opt, i) => v.options[i] === opt));
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".gift-card-pdp__price");
            const compareEl = priceContainer?.querySelector(".gift-card-pdp__price-compare");
            const saleBadge = priceContainer?.querySelector(".gift-card-pdp__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareEl) {
                    compareEl.textContent = formatMoney(variant.compareAtPrice);
                    compareEl.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("gift-card-pdp__price-sale");
                priceElement.classList.remove("gift-card-pdp__price-regular");
            } else {
                if (compareEl) compareEl.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("gift-card-pdp__price-sale");
                priceElement.classList.add("gift-card-pdp__price-regular");
            }
        }
        if (variant.image) {
            fadeSwapImage(mainImage, variant.image);
        }
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (!variantId) return;
        const variant = variantData.variants.find(v => v.id === parseInt(variantId, 10));
        if (!variant) return;
        variant.options.forEach((value, i) => {
            const input = document.querySelector(`.gift-card-pdp__option-input[name="options[${variantData.options[i]}]"][value="${value}"]`);
            if (input) input.checked = true;
        });
        updateVariantUI(variant);
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const variant = findVariantByOptions(getSelectedOptions());
                if (variant) updateVariantUI(variant);
            });
        });
        initVariantFromURL();
    }
    if (messageTextarea && messageCounter) {
        const updateCount = () => {
            messageCounter.textContent = messageTextarea.value.length;
        };
        messageTextarea.addEventListener("input", updateCount);
        updateCount();
    }
    function setGiftToggle(expanded) {
        if (!recipientWrap) return;
        recipientWrap.classList.toggle("is-expanded", expanded);
        recipientWrap.setAttribute("aria-hidden", String(!expanded));
        sendAsGiftCheckbox?.setAttribute("aria-expanded", String(expanded));
        recipientWrap.querySelectorAll("input, textarea").forEach(el => {
            el.disabled = !expanded;
        });
        if (!expanded && recipientEmailInput) {
            recipientEmailInput.classList.remove("is-invalid");
            if (recipientEmailError) {
                recipientEmailError.textContent = "";
                recipientEmailError.classList.remove("is-visible");
            }
        }
    }
    if (sendAsGiftCheckbox) {
        sendAsGiftCheckbox.addEventListener("change", () => setGiftToggle(sendAsGiftCheckbox.checked));
        setGiftToggle(sendAsGiftCheckbox.checked);
    }
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function validateRecipientEmail() {
        if (!recipientEmailInput) return true;
        if (sendAsGiftCheckbox && !sendAsGiftCheckbox.checked) return true;
        const sendingAsGift = !!(sendAsGiftCheckbox && sendAsGiftCheckbox.checked);
        const required = sendingAsGift || recipientEmailInput.dataset.required === "true";
        const value = recipientEmailInput.value.trim();
        let errorKey = "";
        if (required && !value) {
            errorKey = "required";
        } else if (value && !EMAIL_REGEX.test(value)) {
            errorKey = "invalid";
        }
        if (errorKey) {
            recipientEmailInput.classList.add("is-invalid");
            if (recipientEmailError) {
                recipientEmailError.textContent = errorKey === "required" ? window.giftCardStrings?.emailRequired || "Recipient email is required." : window.giftCardStrings?.emailInvalid || "Please enter a valid email address.";
                recipientEmailError.classList.add("is-visible");
            }
            return false;
        }
        recipientEmailInput.classList.remove("is-invalid");
        if (recipientEmailError) {
            recipientEmailError.textContent = "";
            recipientEmailError.classList.remove("is-visible");
        }
        return true;
    }
    if (recipientEmailInput) {
        recipientEmailInput.addEventListener("blur", validateRecipientEmail);
        recipientEmailInput.addEventListener("input", () => {
            if (recipientEmailInput.classList.contains("is-invalid")) validateRecipientEmail();
        });
    }
    if (productForm) {
        productForm.addEventListener("submit", async e => {
            e.preventDefault();
            if (!validateRecipientEmail()) {
                if (recipientEmailInput) {
                    recipientEmailInput.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                    setTimeout(() => recipientEmailInput.focus({
                        preventScroll: true
                    }), 350);
                }
                return;
            }
            const formData = new FormData(productForm);
            const submitButton = addToCartBtn;
            const originalText = submitButton?.textContent;
            const properties = {};
            [ "Recipient name", "Recipient email", "Message", "Send on" ].forEach(key => {
                const val = formData.get(`properties[${key}]`);
                if (val && val.toString().trim() !== "") {
                    properties[key] = val.toString().trim();
                }
            });
            if (sendAsGiftCheckbox && sendAsGiftCheckbox.checked) {
                properties["__shopify_send_gift_card_to_recipient"] = "on";
            }
            const payload = {
                id: formData.get("id"),
                quantity: 1,
                sections: "cart-drawer-items,cart-header-dropdown"
            };
            if (Object.keys(properties).length > 0) payload.properties = properties;
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = window.giftCardStrings?.adding || "Adding...";
            }
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) {
                    const errBody = await response.json().catch(() => ({}));
                    throw new Error(errBody.description || "Failed to add gift card to cart");
                }
                const data = await response.json();
                if (window.cartDrawer && data.sections) {
                    window.cartDrawer.updateCartSections(data.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: data.items ? data.items[0] : data,
                        sections: data.sections
                    }
                }));
                if (submitButton) {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            } catch (error) {
                console.error("[Gift Card PDP] Error adding to cart:", error);
                alert(error.message || "Sorry, there was an error adding the gift card to your cart. Please try again.");
                if (submitButton) {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            }
        });
    }
    const enlargeBtn = document.getElementById("giftCardEnlargeBtn");
    const zoomModal = document.getElementById("giftCardZoomModal");
    const zoomImage = document.getElementById("giftCardZoomImage");
    const zoomOverlay = document.getElementById("giftCardZoomOverlay");
    const zoomCloseBtn = document.getElementById("giftCardZoomCloseBtn");
    if (enlargeBtn && zoomModal && zoomImage && mainImage) {
        const openModal = () => {
            zoomImage.src = mainImage.src;
            if (typeof gsap !== "undefined") {
                gsap.set(zoomModal, {
                    display: "flex"
                });
                gsap.fromTo(zoomModal, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                });
            } else {
                zoomModal.style.display = "flex";
                zoomModal.style.opacity = "1";
            }
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            if (typeof gsap !== "undefined") {
                gsap.to(zoomModal, {
                    opacity: 0,
                    duration: .3,
                    ease: "power2.in",
                    onComplete: () => {
                        gsap.set(zoomModal, {
                            display: "none"
                        });
                        zoomImage.src = "";
                    }
                });
            } else {
                zoomModal.style.display = "none";
                zoomImage.src = "";
            }
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        zoomCloseBtn?.addEventListener("click", closeModal);
        zoomOverlay?.addEventListener("click", closeModal);
        document.addEventListener("keydown", e => {
            if (e.key === "Escape" && zoomModal.style.display === "flex") closeModal();
        });
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-chemistrie"] && !Shopify.designMode) return;
  try {
    function closeAllHeaderElements() {
    const searchField = document.querySelector("[data-search-field]");
    if (searchField) searchField.classList.remove("is-active");
    const header = document.querySelector(".chemistrie-header");
    if (header) header.classList.remove("search-active");
    const promotionsDialog = document.querySelector("[data-promotions-dialog]");
    if (promotionsDialog && promotionsDialog.classList.contains("is-active")) {
        promotionsDialog.classList.remove("is-active");
        document.body.style.overflow = "";
    }
    const accountDropdown = document.querySelector("[data-account-dropdown]");
    if (accountDropdown) accountDropdown.classList.remove("is-active");
    const cartDropdown = document.querySelector("[data-cart-dropdown]");
    if (cartDropdown) cartDropdown.classList.remove("is-active");
    const hamburgerMenu = document.querySelector("[data-dropdown-menu]");
    if (hamburgerMenu) hamburgerMenu.classList.remove("is-active");
    const mobileClipsOverlay = document.querySelector("[data-mobile-clips-overlay]");
    if (mobileClipsOverlay) {
        mobileClipsOverlay.classList.remove("is-active");
    }
    const mobileExtraOverlay = document.querySelector("[data-mobile-extra-overlay]");
    if (mobileExtraOverlay) {
        mobileExtraOverlay.classList.remove("is-active");
    }
    const navDropdowns = document.querySelectorAll(".chemistrie-header__nav-item--has-dropdown");
    navDropdowns.forEach(item => item.classList.remove("is-active"));
}

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".chemistrie-header");
    if (header) {
        header.classList.add("is-sticky");
        document.body.classList.add("header-is-sticky");
    }
    const announcementBar = document.querySelector(".announcement-bar");
    function updateHeaderStackHeight() {
        const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const headerHeight = header ? header.offsetHeight : 0;
        document.body.style.setProperty("--chemistrie-header-stack-height", announcementHeight + headerHeight + "px");
    }
    updateHeaderStackHeight();
    window.addEventListener("resize", updateHeaderStackHeight);
    if (typeof ResizeObserver !== "undefined") {
        const ro = new ResizeObserver(updateHeaderStackHeight);
        if (header) ro.observe(header);
        if (announcementBar) ro.observe(announcementBar);
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".chemistrie-header");
    const searchToggle = document.querySelector('[data-action="search-toggle"]');
    const searchField = document.querySelector("[data-search-field]");
    const searchInput = document.querySelector(".chemistrie-header__search-input");
    const searchSlidedown = document.querySelector("[data-search-slidedown]");
    const searchSlidedownInput = document.querySelector("[data-search-slidedown-input]");
    const searchSlidedownClose = document.querySelector("[data-search-slidedown-close]");
    function isMobile() {
        return window.innerWidth <= 768;
    }
    function openSearch() {
        if (isMobile()) {
            if (header) header.classList.add("search-active");
            setTimeout(() => {
                if (searchSlidedownInput) searchSlidedownInput.focus();
            }, 300);
        } else {
            searchField.classList.add("is-active");
            setTimeout(() => {
                searchInput.focus();
            }, 100);
        }
    }
    function closeSearch() {
        searchField.classList.remove("is-active");
        if (header) header.classList.remove("search-active");
        if (searchInput) searchInput.blur();
        if (searchSlidedownInput) searchSlidedownInput.blur();
    }
    if (searchToggle) {
        searchToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = isMobile() ? header.classList.contains("search-active") : searchField.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                openSearch();
            }
        });
        if (searchSlidedownClose) {
            searchSlidedownClose.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeSearch();
            });
        }
        document.addEventListener("click", function(e) {
            const isInsideDesktopSearch = searchField && searchField.contains(e.target);
            const isInsideMobileSearch = searchSlidedown && searchSlidedown.contains(e.target);
            const isSearchToggle = searchToggle.contains(e.target);
            if (!isInsideDesktopSearch && !isInsideMobileSearch && !isSearchToggle) {
                closeSearch();
            }
        });
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                const isSearchActive = isMobile() ? header.classList.contains("search-active") : searchField.classList.contains("is-active");
                if (isSearchActive) {
                    closeSearch();
                }
            }
        });
        window.addEventListener("resize", function() {
            if (!isMobile() && header && header.classList.contains("search-active")) {
                header.classList.remove("search-active");
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const promotionsToggle = document.querySelector('[data-action="promotions-toggle"]');
    const promotionsDialog = document.querySelector("[data-promotions-dialog]");
    const promotionsOverlay = document.querySelector("[data-promotions-overlay]");
    const promotionsClose = document.querySelector("[data-promotions-close]");
    const copyCodeBtn = document.querySelector("[data-copy-code]");
    const emailForm = document.querySelector("[data-email-form]");
    if (promotionsToggle && promotionsDialog) {
        promotionsToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = promotionsDialog.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                promotionsDialog.classList.add("is-active");
                document.body.style.overflow = "hidden";
            }
        });
        function closeDialog() {
            promotionsDialog.classList.remove("is-active");
            document.body.style.overflow = "";
        }
        if (promotionsOverlay) {
            promotionsOverlay.addEventListener("click", closeDialog);
        }
        if (promotionsClose) {
            promotionsClose.addEventListener("click", closeDialog);
        }
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape" && promotionsDialog.classList.contains("is-active")) {
                closeDialog();
            }
        });
        if (copyCodeBtn) {
            copyCodeBtn.addEventListener("click", function() {
                const code = this.getAttribute("data-copy-code");
                navigator.clipboard.writeText(code).then(() => {
                    this.textContent = "Copied!";
                    setTimeout(() => {
                        this.textContent = "Copy";
                    }, 2e3);
                });
            });
        }
        if (emailForm) {
            emailForm.addEventListener("submit", function(e) {
                e.preventDefault();
                const email = this.querySelector('input[type="email"]').value;
                const submitBtn = this.querySelector('button[type="submit"]');
                submitBtn.textContent = "Subscribed!";
                submitBtn.disabled = true;
                submitBtn.style.background = "#28a745";
                setTimeout(() => {
                    this.querySelector('input[type="email"]').value = "";
                    submitBtn.textContent = "Subscribe";
                    submitBtn.disabled = false;
                    submitBtn.style.background = "";
                    closeDialog();
                }, 2e3);
            });
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const accountToggle = document.querySelector('[data-action="account-toggle"]');
    const accountDropdown = document.querySelector("[data-account-dropdown]");
    if (accountToggle && accountDropdown) {
        accountToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = accountDropdown.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                accountDropdown.classList.add("is-active");
            }
        });
    }
    document.addEventListener("click", function(e) {
        if (accountDropdown && !accountDropdown.contains(e.target) && !accountToggle.contains(e.target)) {
            accountDropdown.classList.remove("is-active");
        }
    });
    const accountLinks = document.querySelectorAll(".chemistrie-header__account-link");
    accountLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (accountDropdown) {
                accountDropdown.classList.remove("is-active");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const cartToggle = document.querySelector('[data-action="cart-toggle"]');
    const cartDropdown = document.querySelector("[data-cart-dropdown]");
    if (cartToggle && cartDropdown) {
        cartToggle.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.cartDrawer) {
                window.cartDrawer.openDrawer();
            }
        });
    }
    document.addEventListener("click", function(e) {
        if (cartDropdown && !cartDropdown.contains(e.target) && !cartToggle.contains(e.target)) {
            cartDropdown.classList.remove("is-active");
        }
    });
    const cartLinks = document.querySelectorAll(".chemistrie-header__cart-view, .chemistrie-header__cart-checkout");
    cartLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (cartDropdown) {
                cartDropdown.classList.remove("is-active");
            }
        });
    });
    document.addEventListener("cart:item:added", function(e) {
        console.log("Cart item added event received:", e.detail);
        closeAllHeaderElements();
        if (window.cartDrawer) {
            window.cartDrawer.openDrawer();
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const menuToggle = document.querySelector('[data-action="menu-toggle"]');
    const dropdownMenu = document.querySelector("[data-dropdown-menu]");
    const mobileClipsOverlay = document.querySelector("[data-mobile-clips-overlay]");
    const mobileExtraOverlay = document.querySelector("[data-mobile-extra-overlay]");
    if (menuToggle && dropdownMenu) {
        menuToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            if (mobileClipsOverlay && mobileClipsOverlay.classList.contains("is-active") || mobileExtraOverlay && mobileExtraOverlay.classList.contains("is-active")) {
                if (mobileClipsOverlay) mobileClipsOverlay.classList.remove("is-active");
                if (mobileExtraOverlay) mobileExtraOverlay.classList.remove("is-active");
                dropdownMenu.classList.add("is-active");
                return;
            }
            const wasActive = dropdownMenu.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                dropdownMenu.classList.add("is-active");
            }
        });
    }
    const mobileClipsBtn = document.querySelector('[data-action="mobile-clips-menu"]');
    if (mobileClipsBtn && mobileClipsOverlay && dropdownMenu) {
        mobileClipsBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdownMenu.classList.remove("is-active");
            mobileClipsOverlay.classList.add("is-active");
        });
    }
    const mobileExtraBtn = document.querySelector('[data-action="mobile-extra-menu"]');
    if (mobileExtraBtn && mobileExtraOverlay && dropdownMenu) {
        mobileExtraBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdownMenu.classList.remove("is-active");
            mobileExtraOverlay.classList.add("is-active");
        });
    }
    document.addEventListener("click", function(e) {
        if (dropdownMenu && !dropdownMenu.contains(e.target) && !menuToggle.contains(e.target)) {
            dropdownMenu.classList.remove("is-active");
        }
        if (mobileClipsOverlay && mobileClipsOverlay.classList.contains("is-active") && !mobileClipsOverlay.contains(e.target) && !menuToggle.contains(e.target)) {
            mobileClipsOverlay.classList.remove("is-active");
        }
        if (mobileExtraOverlay && mobileExtraOverlay.classList.contains("is-active") && !mobileExtraOverlay.contains(e.target) && !menuToggle.contains(e.target)) {
            mobileExtraOverlay.classList.remove("is-active");
        }
    });
    const dropdownLinks = document.querySelectorAll('.chemistrie-header__dropdown-link:not(.chemistrie-header__dropdown-link--expandable):not([data-action="mobile-clips-menu"]):not([data-action="mobile-extra-menu"])');
    dropdownLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (dropdownMenu) {
                dropdownMenu.classList.remove("is-active");
            }
        });
    });
    const expandableToggles = document.querySelectorAll("[data-mobile-nav-toggle]");
    expandableToggles.forEach(toggle => {
        toggle.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const navItem = this.closest("[data-mobile-nav-expandable]");
            if (navItem) {
                expandableToggles.forEach(otherToggle => {
                    const otherItem = otherToggle.closest("[data-mobile-nav-expandable]");
                    if (otherItem && otherItem !== navItem) {
                        otherItem.classList.remove("is-expanded");
                    }
                });
                navItem.classList.toggle("is-expanded");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(e) {
        const header = document.querySelector(".chemistrie-header");
        const promotionsDialog = document.querySelector("[data-promotions-dialog]");
        if (header && !header.contains(e.target) && (!promotionsDialog || !promotionsDialog.contains(e.target))) {
            closeAllHeaderElements();
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const megaNavItems = document.querySelectorAll(".chemistrie-header__nav-item--has-mega-menu");
    megaNavItems.forEach(function(navItem) {
        const megaMenuWrapper = navItem.querySelector(".chemistrie-header__mega-menu");
        if (!megaMenuWrapper) return;
        const megaMenu = megaMenuWrapper.querySelector(".clips-mega-menu");
        if (!megaMenu) return;
        const scrollContainer = megaMenu.querySelector(".clips-mega-menu__container");
        const leftArrow = megaMenu.querySelector(".clips-mega-scroll-arrow--left");
        const rightArrow = megaMenu.querySelector(".clips-mega-scroll-arrow--right");
        if (!scrollContainer || !leftArrow || !rightArrow) return;
        let initialStateSet = false;
        function updateScrollState() {
            if (scrollContainer.clientWidth === 0) return;
            const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
            const scrollLeft = scrollContainer.scrollLeft;
            const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
            const atStart = scrollLeft <= 10;
            const atEnd = scrollLeft >= maxScroll - 10 || maxScroll <= 0;
            megaMenu.classList.toggle("is-scrollable", isScrollable);
            megaMenu.classList.toggle("at-start", atStart);
            megaMenu.classList.toggle("at-end", atEnd);
        }
        leftArrow.addEventListener("click", function(e) {
            e.stopPropagation();
            scrollContainer.scrollBy({
                left: -800,
                behavior: "smooth"
            });
        });
        rightArrow.addEventListener("click", function(e) {
            e.stopPropagation();
            scrollContainer.scrollBy({
                left: 800,
                behavior: "smooth"
            });
        });
        scrollContainer.addEventListener("scroll", updateScrollState);
        window.addEventListener("resize", updateScrollState);
        navItem.addEventListener("mouseenter", function() {
            requestAnimationFrame(function() {
                setTimeout(function() {
                    if (!initialStateSet) {
                        megaMenu.classList.add("at-start");
                        initialStateSet = true;
                    }
                    updateScrollState();
                }, 50);
            });
        });
        megaMenu.classList.add("at-start");
        updateScrollState();
    });
});

document.addEventListener("DOMContentLoaded", function() {
    function updateHeaderHeight() {
        const header = document.querySelector(".chemistrie-header");
        if (header) {
            const headerHeight = header.offsetHeight;
            const announcementBar = document.querySelector(".announcement-bar");
            const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
            document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
            document.documentElement.style.setProperty("--header-bottom-offset", `${headerHeight + announcementHeight}px`);
        }
    }
    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
});

document.addEventListener("DOMContentLoaded", function() {
    const dropdownItems = document.querySelectorAll(".chemistrie-header__nav-item--has-dropdown");
    dropdownItems.forEach(item => {
        const link = item.querySelector(".chemistrie-header__nav-link");
        if (link) {
            link.addEventListener("click", function(e) {
                if (window.innerWidth <= 768) {
                    e.preventDefault();
                    e.stopPropagation();
                    const hamburgerMenu = document.querySelector("[data-dropdown-menu]");
                    if (hamburgerMenu) {
                        hamburgerMenu.classList.remove("is-active");
                    }
                    dropdownItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove("is-active");
                        }
                    });
                    item.classList.toggle("is-active");
                }
            });
        }
    });
    document.addEventListener("click", function(e) {
        if (window.innerWidth <= 768) {
            const isClickInside = Array.from(dropdownItems).some(item => item.contains(e.target));
            if (!isClickInside) {
                dropdownItems.forEach(item => item.classList.remove("is-active"));
            }
        }
    });
    window.addEventListener("resize", function() {
        if (window.innerWidth > 768) {
            dropdownItems.forEach(item => item.classList.remove("is-active"));
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hidden-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector(".hidden-product__slider");
    if (!slider) return;
    const scrollContainer = slider.querySelector(".hidden-product__cards");
    const leftArrow = slider.querySelector(".hidden-product__scroll-arrow--left");
    const rightArrow = slider.querySelector(".hidden-product__scroll-arrow--right");
    const leftFade = slider.querySelector(".hidden-product__fade--left");
    const rightFade = slider.querySelector(".hidden-product__fade--right");
    if (!scrollContainer || !leftArrow || !rightArrow) return;
    const scrollAmount = 280;
    function updateArrowsAndFades() {
        const scrollLeft = scrollContainer.scrollLeft;
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        leftArrow.disabled = scrollLeft <= 0;
        rightArrow.disabled = scrollLeft >= maxScroll - 1;
        if (leftFade) {
            leftFade.style.opacity = scrollLeft > 0 ? "1" : "0";
        }
        if (rightFade) {
            rightFade.style.opacity = scrollLeft < maxScroll - 1 ? "1" : "0";
        }
    }
    leftArrow.addEventListener("click", function() {
        scrollContainer.scrollBy({
            left: -scrollAmount,
            behavior: "smooth"
        });
    });
    rightArrow.addEventListener("click", function() {
        scrollContainer.scrollBy({
            left: scrollAmount,
            behavior: "smooth"
        });
    });
    scrollContainer.addEventListener("scroll", updateArrowsAndFades);
    updateArrowsAndFades();
    window.addEventListener("resize", updateArrowsAndFades);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-best-seller"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".best-seller__cta-button").forEach(function(button) {
        const text = button.textContent.trim();
        const firstSpaceIndex = text.indexOf(" ");
        if (firstSpaceIndex !== -1) {
            const firstWord = text.substring(0, firstSpaceIndex);
            const restOfText = text.substring(firstSpaceIndex + 1);
            button.innerHTML = '<span class="best-seller__cta-line1">' + firstWord + "</span>" + '<span class="best-seller__cta-line2">' + restOfText + "</span>";
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-color-wheel"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const assetData = JSON.parse(document.getElementById("colorwheel-assets").textContent);
    const ColorSelectorComponent = {
        colorData: {
            gradient: [ "Amber", "CrimsonGrey", "DarkBrown", "DarkGrey", "MediumBrown", "Rouge", "VioletGrey", "VioletRose" ],
            mirror: [ "Blue", "Caliente", "Gold", "Green", "Morado", "Orange", "Silver", "SkyBlue" ],
            solid: [ "Amber", "Blue", "Bronze", "Brown", "G15", "Grey", "Rose", "Yellow" ]
        },
        currentCategory: "gradient",
        currentColor: "CrimsonGrey",
        elements: {
            lensOverlay: null,
            colorRows: null
        },
        init() {
            this.cacheElements();
            this.renderAllColorRows();
            this.preloadImages();
            this.initializeTabs();
            this.showActiveCategory();
        },
        cacheElements() {
            this.elements.lensOverlay = document.getElementById("lens-overlay");
            this.elements.colorRows = document.querySelectorAll(".color-pucks-row");
        },
        renderAllColorRows() {
            this.elements.colorRows.forEach(row => {
                const category = row.getAttribute("data-category");
                const colors = this.colorData[category];
                row.innerHTML = "";
                colors.forEach(color => {
                    const puck = this.createColorPuck(color, category);
                    row.appendChild(puck);
                });
            });
        },
        createColorPuck(colorName, category) {
            const puck = document.createElement("button");
            puck.className = "color-puck";
            puck.setAttribute("data-color", colorName);
            puck.setAttribute("data-category", category);
            puck.setAttribute("aria-label", `Select ${this.formatColorName(colorName)} ${category} lens`);
            const imageContainer = document.createElement("div");
            imageContainer.className = "color-puck-image";
            const img = document.createElement("img");
            img.src = assetData.lensPucks[category][colorName];
            img.alt = this.formatColorName(colorName);
            imageContainer.appendChild(img);
            puck.appendChild(imageContainer);
            const label = document.createElement("span");
            label.className = "color-puck-label";
            label.textContent = this.formatColorName(colorName);
            puck.appendChild(label);
            if (colorName === this.currentColor && category === this.currentCategory) {
                puck.classList.add("selected");
            }
            puck.addEventListener("click", () => {
                this.selectColor(colorName, category);
            });
            puck.addEventListener("keydown", e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.selectColor(colorName, category);
                }
            });
            return puck;
        },
        selectColor(colorName, category) {
            this.currentColor = colorName;
            this.currentCategory = category;
            document.querySelectorAll(".color-puck").forEach(puck => {
                puck.classList.remove("selected");
            });
            document.querySelectorAll(".color-puck").forEach(puck => {
                if (puck.getAttribute("data-color") === colorName && puck.getAttribute("data-category") === category) {
                    puck.classList.add("selected");
                }
            });
            this.updateLensOverlay(colorName);
        },
        updateLensOverlay(colorName) {
            const overlay = this.elements.lensOverlay;
            const newSrc = assetData.lensOverlays[this.currentCategory][colorName];
            overlay.classList.add("changing");
            const newImage = new Image;
            newImage.onload = () => {
                overlay.src = newSrc;
                setTimeout(() => {
                    overlay.classList.remove("changing");
                }, 50);
            };
            newImage.src = newSrc;
        },
        formatColorName(colorName) {
            return colorName.replace(/([A-Z])/g, " $1").trim();
        },
        preloadImages() {
            Object.keys(this.colorData).forEach(category => {
                this.colorData[category].forEach(color => {
                    const img = new Image;
                    img.src = assetData.lensOverlays[category][color];
                });
            });
        },
        initializeTabs() {
            const tabButtons = document.querySelectorAll(".mobile-tab-button");
            tabButtons.forEach(button => {
                button.addEventListener("click", e => {
                    const category = e.target.getAttribute("data-tab");
                    this.switchTab(category);
                });
            });
        },
        switchTab(category) {
            document.querySelectorAll(".mobile-tab-button").forEach(btn => {
                btn.classList.remove("active");
            });
            document.querySelector(`[data-tab="${category}"]`).classList.add("active");
            this.currentCategory = category;
            this.showActiveCategory();
        },
        showActiveCategory() {
            document.querySelectorAll(".mobile-color-rows .color-row").forEach(row => {
                row.classList.remove("active");
            });
            const mobileActiveRow = document.querySelector(`.mobile-color-rows [data-row="${this.currentCategory}"]`);
            if (mobileActiveRow) {
                mobileActiveRow.classList.add("active");
            }
        }
    };
    ColorSelectorComponent.init();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-diagram"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const container = document.getElementById("parallax-container");
    const image = document.getElementById("parallax-image");
    if (!container || !image) return;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const isMobile = window.innerWidth <= 768;
    const config = {
        rotationRange: isMobile ? 2 : 3.75,
        translationRange: isMobile ? 2.5 : 5,
        scaleRange: isMobile ? .005 : .0125,
        perspective: 1200,
        smooth: .1,
        zTranslation: isMobile ? 3.75 : 7.5
    };
    let isActive = false;
    let animationId = null;
    let targetTransform = {
        rotateX: 0,
        rotateY: 0,
        translateX: 0,
        translateY: 0,
        translateZ: 0,
        scale: isMobile ? 1 : 1.05
    };
    let currentTransform = {
        ...targetTransform
    };
    function animate() {
        currentTransform.rotateX += (targetTransform.rotateX - currentTransform.rotateX) * config.smooth;
        currentTransform.rotateY += (targetTransform.rotateY - currentTransform.rotateY) * config.smooth;
        currentTransform.translateX += (targetTransform.translateX - currentTransform.translateX) * config.smooth;
        currentTransform.translateY += (targetTransform.translateY - currentTransform.translateY) * config.smooth;
        currentTransform.translateZ += (targetTransform.translateZ - currentTransform.translateZ) * config.smooth;
        currentTransform.scale += (targetTransform.scale - currentTransform.scale) * config.smooth;
        const transform = `\n      perspective(${config.perspective}px)\n      rotateX(${currentTransform.rotateX}deg)\n      rotateY(${currentTransform.rotateY}deg)\n      translateX(${currentTransform.translateX}px)\n      translateY(${currentTransform.translateY}px)\n      translateZ(${currentTransform.translateZ}px)\n      scale(${currentTransform.scale})\n    `;
        image.style.transform = transform;
        if (isActive) {
            animationId = requestAnimationFrame(animate);
        }
    }
    function updateParallax(x, y) {
        const rect = container.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const relativeX = (x - centerX) / (rect.width / 2);
        const relativeY = (y - centerY) / (rect.height / 2);
        const easedX = relativeX * Math.abs(relativeX);
        const easedY = relativeY * Math.abs(relativeY);
        targetTransform.rotateY = easedX * config.rotationRange;
        targetTransform.rotateX = -easedY * config.rotationRange;
        targetTransform.translateX = easedX * config.translationRange;
        targetTransform.translateY = easedY * config.translationRange;
        targetTransform.translateZ = config.zTranslation;
        targetTransform.scale = (isMobile ? 1 : 1.05) + Math.abs(easedX + easedY) * .5 * config.scaleRange;
    }
    function resetParallax() {
        targetTransform = {
            rotateX: 0,
            rotateY: 0,
            translateX: 0,
            translateY: 0,
            translateZ: 0,
            scale: isMobile ? 1 : 1.05
        };
    }
    function handleMouseEnter() {
        if (!isActive) {
            isActive = true;
            image.classList.add("parallax-active");
            animate();
        }
    }
    function handleMouseMove(e) {
        if (isActive) {
            updateParallax(e.clientX, e.clientY);
        }
    }
    function handleMouseLeave() {
        isActive = false;
        image.classList.remove("parallax-active");
        resetParallax();
        if (animationId) {
            cancelAnimationFrame(animationId);
        }
        const exitAnimation = () => {
            const hasMovement = Math.abs(currentTransform.rotateX) > .1 || Math.abs(currentTransform.rotateY) > .1 || Math.abs(currentTransform.translateX) > .1 || Math.abs(currentTransform.translateY) > .1 || Math.abs(currentTransform.translateZ) > .1;
            if (hasMovement) {
                animate();
                requestAnimationFrame(exitAnimation);
            }
        };
        exitAnimation();
    }
    function handleTouchStart(e) {
        if (isMobile && e.touches.length === 1) {
            handleMouseEnter();
            const touch = e.touches[0];
            updateParallax(touch.clientX, touch.clientY);
        }
    }
    function handleTouchMove(e) {
        if (isMobile && e.touches.length === 1) {
            e.preventDefault();
            const touch = e.touches[0];
            updateParallax(touch.clientX, touch.clientY);
        }
    }
    function handleTouchEnd() {
        if (isMobile) {
            setTimeout(handleMouseLeave, 100);
        }
    }
    if (!isMobile) {
        container.addEventListener("mouseenter", handleMouseEnter);
        container.addEventListener("mousemove", handleMouseMove);
        container.addEventListener("mouseleave", handleMouseLeave);
    } else {
        container.addEventListener("touchstart", handleTouchStart, {
            passive: false
        });
        container.addEventListener("touchmove", handleTouchMove, {
            passive: false
        });
        container.addEventListener("touchend", handleTouchEnd);
    }
    function handleResize() {
        if (isActive) {
            resetParallax();
        }
    }
    window.addEventListener("resize", handleResize);
    window.parallaxCleanup = function() {
        if (animationId) {
            cancelAnimationFrame(animationId);
        }
        container.removeEventListener("mouseenter", handleMouseEnter);
        container.removeEventListener("mousemove", handleMouseMove);
        container.removeEventListener("mouseleave", handleMouseLeave);
        container.removeEventListener("touchstart", handleTouchStart);
        container.removeEventListener("touchmove", handleTouchMove);
        container.removeEventListener("touchend", handleTouchEnd);
        window.removeEventListener("resize", handleResize);
    };
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-explore-clips"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const navButtons = document.querySelectorAll(".explore-clips__nav-button");
    const cards = document.querySelectorAll(".explore-clips__card");
    const images = document.querySelectorAll(".explore-clips__image");
    const stackPositions = [ {
        x: 0,
        y: 0,
        z: 7
    }, {
        x: -10,
        y: -10,
        z: 6
    }, {
        x: -20,
        y: -20,
        z: 5
    }, {
        x: -30,
        y: -30,
        z: 4
    }, {
        x: -40,
        y: -40,
        z: 3
    }, {
        x: -50,
        y: -50,
        z: 2
    }, {
        x: -60,
        y: -60,
        z: 1
    } ];
    function shuffleCards(targetClip) {
        const currentActiveCard = document.querySelector(".explore-clips__card.active");
        const targetCard = document.querySelector(`.explore-clips__card[data-clip="${targetClip}"]`);
        const currentActiveImage = document.querySelector(".explore-clips__image.active");
        const targetImage = document.querySelector(`.explore-clips__image[data-clip="${targetClip}"]`);
        if (!targetCard || targetCard === currentActiveCard) return;
        const tl = gsap.timeline();
        tl.to(currentActiveCard, {
            y: -20,
            duration: .2,
            ease: "power2.out"
        });
        tl.call(() => {
            currentActiveCard.classList.remove("active");
            currentActiveImage.classList.remove("active");
            const allCards = Array.from(cards);
            const targetIndex = allCards.indexOf(targetCard);
            allCards.splice(targetIndex, 1);
            allCards.unshift(targetCard);
            allCards.forEach((card, index) => {
                const position = stackPositions[index];
                if (card === targetCard) {
                    gsap.set(card, {
                        x: position.x,
                        y: position.y - 20,
                        zIndex: position.z
                    });
                    card.classList.add("active");
                } else {
                    gsap.to(card, {
                        x: position.x,
                        y: position.y,
                        zIndex: position.z,
                        duration: .2,
                        ease: "cubic-bezier(0.4, 0.0, 0.2, 1)"
                    });
                }
            });
        }, null, .2);
        tl.to(targetCard, {
            x: 0,
            y: 0,
            duration: .2,
            ease: "power2.out"
        }, .4);
        tl.to(currentActiveImage, {
            opacity: 0,
            duration: .2,
            ease: "power2.out"
        }, .2);
        tl.set(targetImage, {
            opacity: 0
        }, .2);
        tl.to(targetImage, {
            opacity: 1,
            duration: .2,
            ease: "power2.out",
            onStart: () => {
                targetImage.classList.add("active");
            }
        }, .4);
    }
    navButtons.forEach(button => {
        button.addEventListener("click", function() {
            const targetClip = this.getAttribute("data-clip");
            navButtons.forEach(btn => btn.classList.remove("active"));
            this.classList.add("active");
            shuffleCards(targetClip);
            const mobileDots = document.querySelectorAll(".explore-clips__nav-dot");
            if (mobileDots.length > 0) {
                mobileDots.forEach(dot => {
                    if (dot.getAttribute("data-clip") === targetClip) {
                        dot.classList.add("active");
                    } else {
                        dot.classList.remove("active");
                    }
                });
            }
        });
    });
    cards.forEach(card => {
        card.addEventListener("click", function() {
            const targetClip = this.getAttribute("data-clip");
            const targetButton = document.querySelector(`.explore-clips__nav-button[data-clip="${targetClip}"]`);
            if (targetButton) {
                targetButton.click();
            }
        });
    });
    const mobileDots = document.querySelectorAll(".explore-clips__nav-dot");
    const mobileArrowPrev = document.querySelector(".explore-clips__mobile-nav-arrow--prev");
    const mobileArrowNext = document.querySelector(".explore-clips__mobile-nav-arrow--next");
    function updateActiveDot(clipName) {
        mobileDots.forEach(dot => {
            if (dot.getAttribute("data-clip") === clipName) {
                dot.classList.add("active");
            } else {
                dot.classList.remove("active");
            }
        });
    }
    mobileDots.forEach(dot => {
        dot.addEventListener("click", function() {
            const targetClip = this.getAttribute("data-clip");
            const targetButton = document.querySelector(`.explore-clips__nav-button[data-clip="${targetClip}"]`);
            if (targetButton) {
                targetButton.click();
            } else {
                navButtons.forEach(btn => btn.classList.remove("active"));
                const matchingButton = Array.from(navButtons).find(btn => btn.getAttribute("data-clip") === targetClip);
                if (matchingButton) {
                    matchingButton.classList.add("active");
                }
                shuffleCards(targetClip);
                updateActiveDot(targetClip);
            }
        });
    });
    if (mobileArrowPrev && mobileArrowNext) {
        mobileArrowPrev.addEventListener("click", function() {
            const activeButton = document.querySelector(".explore-clips__nav-button.active");
            const allButtons = Array.from(navButtons);
            const currentIndex = allButtons.indexOf(activeButton);
            const prevIndex = (currentIndex - 1 + allButtons.length) % allButtons.length;
            allButtons[prevIndex].click();
            updateActiveDot(allButtons[prevIndex].getAttribute("data-clip"));
        });
        mobileArrowNext.addEventListener("click", function() {
            const activeButton = document.querySelector(".explore-clips__nav-button.active");
            const allButtons = Array.from(navButtons);
            const currentIndex = allButtons.indexOf(activeButton);
            const nextIndex = (currentIndex + 1) % allButtons.length;
            allButtons[nextIndex].click();
            updateActiveDot(allButtons[nextIndex].getAttribute("data-clip"));
        });
    }
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    const minSwipeDistance = 50;
    const cardStack = document.querySelector(".explore-clips__card-stack");
    if (cardStack && window.innerWidth <= 768) {
        cardStack.addEventListener("touchstart", function(e) {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
        }, {
            passive: true
        });
        cardStack.addEventListener("touchend", function(e) {
            touchEndX = e.changedTouches[0].screenX;
            touchEndY = e.changedTouches[0].screenY;
            handleSwipe();
        }, {
            passive: true
        });
        function handleSwipe() {
            const swipeDistanceX = touchEndX - touchStartX;
            const swipeDistanceY = touchEndY - touchStartY;
            if (Math.abs(swipeDistanceX) > Math.abs(swipeDistanceY) && Math.abs(swipeDistanceX) > minSwipeDistance) {
                const activeButton = document.querySelector(".explore-clips__nav-button.active");
                const allButtons = Array.from(navButtons);
                const currentIndex = allButtons.indexOf(activeButton);
                if (swipeDistanceX < 0) {
                    const nextIndex = (currentIndex + 1) % allButtons.length;
                    allButtons[nextIndex].click();
                    updateActiveDot(allButtons[nextIndex].getAttribute("data-clip"));
                } else {
                    const prevIndex = (currentIndex - 1 + allButtons.length) % allButtons.length;
                    allButtons[prevIndex].click();
                    updateActiveDot(allButtons[prevIndex].getAttribute("data-clip"));
                }
            }
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-how-it-works"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const cardsContainer = document.querySelector("[data-cards-container]");
    const cards = document.querySelectorAll("[data-card]");
    if (!cardsContainer || cards.length === 0) return;
    let activeCard = null;
    let isAnimating = false;
    let currentTimeline = null;
    let debounceTimeout = null;
    cards.forEach(card => {
        const trigger = card.querySelector("[data-card-trigger]");
        const bottom = card.querySelector(".how-it-works__card-bottom");
        const content = card.querySelector(".how-it-works__card-content");
        if (!trigger || !bottom || !content) return;
        trigger.addEventListener("click", function() {
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
                debounceTimeout = null;
            }
            if (isAnimating) {
                forceCompleteReset();
                debounceTimeout = setTimeout(() => {
                    processCardClick(card);
                }, 150);
                return;
            }
            processCardClick(card);
        });
    });
    function forceCompleteReset() {
        if (currentTimeline) {
            currentTimeline.kill();
            currentTimeline = null;
        }
        gsap.killTweensOf("*");
        cards.forEach(resetCardCompletely);
        gsap.set(cardsContainer, {
            x: 0
        });
        isAnimating = false;
        activeCard = null;
    }
    function processCardClick(card) {
        const cardType = card.getAttribute("data-card");
        const isActive = card.getAttribute("data-state") === "expanded";
        if (activeCard && activeCard !== card) {
            switchCards(activeCard, card);
        } else if (isActive) {
            closeCard(card);
        } else {
            openCard(card);
        }
    }
    function resetCardCompletely(card) {
        const bottom = card.querySelector(".how-it-works__card-bottom");
        const content = card.querySelector(".how-it-works__card-content");
        gsap.killTweensOf([ card, bottom, content ]);
        card.setAttribute("data-state", "closed");
        gsap.set(card, {
            clearProps: "all"
        });
        gsap.set(bottom, {
            width: 320
        });
        gsap.set(content, {
            opacity: 0,
            x: 0
        });
        if (card === activeCard) {
            activeCard = null;
        }
    }
    function switchCards(fromCard, toCard) {
        isAnimating = true;
        const fromCardType = fromCard.getAttribute("data-card");
        const toCardType = toCard.getAttribute("data-card");
        const fromBottom = fromCard.querySelector(".how-it-works__card-bottom");
        const fromContent = fromCard.querySelector(".how-it-works__card-content");
        const toBottom = toCard.querySelector(".how-it-works__card-bottom");
        const toContent = toCard.querySelector(".how-it-works__card-content");
        const otherCardWhenClosing = document.querySelector(`[data-card]:not([data-card="${fromCardType}"])`);
        const otherCardWhenOpening = document.querySelector(`[data-card]:not([data-card="${toCardType}"])`);
        fromCard.setAttribute("data-state", "closed");
        toCard.setAttribute("data-state", "expanded");
        activeCard = toCard;
        currentTimeline = gsap.timeline({
            onComplete: () => {
                isAnimating = false;
                currentTimeline = null;
            }
        });
        currentTimeline.to(fromContent, {
            opacity: 0,
            duration: .2,
            ease: "power1.in"
        });
        currentTimeline.to([ cardsContainer, otherCardWhenClosing ], {
            x: 0,
            duration: .4,
            ease: "power1.inOut"
        }, .1);
        currentTimeline.to(fromCard, {
            x: 0,
            y: 0,
            duration: .4,
            ease: "power1.inOut"
        }, .1);
        currentTimeline.to(fromBottom, {
            width: 320,
            duration: .4,
            ease: "power1.inOut"
        }, .1);
        currentTimeline.to(cardsContainer, {
            x: -210,
            duration: .5,
            ease: "power1.out"
        }, .5);
        currentTimeline.to(toBottom, {
            width: 740,
            duration: .5,
            ease: "power1.out"
        }, .5);
        if (toCardType === "own-frame") {
            currentTimeline.to(otherCardWhenOpening, {
                x: 420,
                duration: .5,
                ease: "power1.out"
            }, .5);
        }
        currentTimeline.to(toContent, {
            opacity: 1,
            duration: .3,
            ease: "power1.out"
        }, .7);
    }
    function openCard(card) {
        isAnimating = true;
        const cardType = card.getAttribute("data-card");
        const otherCard = document.querySelector(`[data-card]:not([data-card="${cardType}"])`);
        const bottom = card.querySelector(".how-it-works__card-bottom");
        const content = card.querySelector(".how-it-works__card-content");
        card.setAttribute("data-state", "expanded");
        activeCard = card;
        currentTimeline = gsap.timeline({
            onComplete: () => {
                isAnimating = false;
                currentTimeline = null;
            }
        });
        if (cardType === "own-frame") {
            currentTimeline.to(cardsContainer, {
                x: -210,
                duration: .5,
                ease: "power1.out"
            }, 0).to(bottom, {
                width: 740,
                duration: .5,
                ease: "power1.out"
            }, 0).to(otherCard, {
                x: 420,
                duration: .5,
                ease: "power1.out"
            }, 0).to(content, {
                opacity: 1,
                duration: .3,
                ease: "power1.out",
                delay: .2
            });
        } else {
            currentTimeline.to(cardsContainer, {
                x: -210,
                duration: .5,
                ease: "power1.out"
            }, 0).to(bottom, {
                width: 740,
                duration: .5,
                ease: "power1.out"
            }, 0).to(content, {
                opacity: 1,
                duration: .3,
                ease: "power1.out",
                delay: .2
            });
        }
    }
    function closeCard(card) {
        isAnimating = true;
        const cardType = card.getAttribute("data-card");
        const otherCard = document.querySelector(`[data-card]:not([data-card="${cardType}"])`);
        const bottom = card.querySelector(".how-it-works__card-bottom");
        const content = card.querySelector(".how-it-works__card-content");
        card.setAttribute("data-state", "closed");
        activeCard = null;
        currentTimeline = gsap.timeline({
            onComplete: () => {
                isAnimating = false;
                currentTimeline = null;
            }
        });
        currentTimeline.to(content, {
            opacity: 0,
            duration: .2,
            ease: "power1.in"
        }).to([ cardsContainer, otherCard ], {
            x: 0,
            duration: .4,
            ease: "power1.inOut"
        }, .1).to(card, {
            x: 0,
            y: 0,
            duration: .4,
            ease: "power1.inOut"
        }, .1).to(bottom, {
            width: 320,
            duration: .4,
            ease: "power1.inOut"
        }, .1);
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-seo-content"] && !Shopify.designMode) return;
  try {
    (function() {
    var WORD_LIMIT = 150;
    var MORE_RE = /<!--\s*more\s*-->/i;
    function setToggleText(toggleBtn, expanded) {
        var toggleText = toggleBtn.querySelector("[data-home-seo-toggle-text]");
        if (toggleText) {
            toggleText.textContent = expanded ? toggleBtn.dataset.lessText : toggleBtn.dataset.moreText;
        }
    }
    function initHomeSeoExpand() {
        var sections = document.querySelectorAll("[data-home-seo-expandable]");
        sections.forEach(function(wrapper) {
            if (wrapper.dataset.homeSeoInitialized) return;
            wrapper.dataset.homeSeoInitialized = "true";
            var contentEl = wrapper.querySelector("[data-home-seo-content]");
            var card = wrapper.closest(".home-seo__card");
            var toggleBtn = card ? card.querySelector("[data-home-seo-toggle]") : null;
            if (!contentEl || !toggleBtn) return;
            if (!toggleBtn.dataset.moreText) {
                toggleBtn.dataset.moreText = toggleBtn.querySelector("[data-home-seo-toggle-text]").textContent;
            }
            if (!toggleBtn.dataset.lessText) {
                toggleBtn.dataset.lessText = "Read less";
            }
            var html = contentEl.innerHTML;
            if (MORE_RE.test(html)) {
                var parts = html.split(MORE_RE);
                var before = parts[0];
                var after = parts.slice(1).join("");
                contentEl.innerHTML = before + "<div data-home-seo-extra hidden>" + after + "</div>";
                var extraEl = contentEl.querySelector("[data-home-seo-extra]");
                toggleBtn.hidden = false;
                toggleBtn.addEventListener("click", function() {
                    var isHidden = extraEl.hasAttribute("hidden");
                    if (isHidden) {
                        extraEl.removeAttribute("hidden");
                    } else {
                        extraEl.setAttribute("hidden", "");
                    }
                    toggleBtn.setAttribute("aria-expanded", String(isHidden));
                    setToggleText(toggleBtn, isHidden);
                });
                return;
            }
            var text = contentEl.textContent || "";
            var wordCount = text.trim().split(/\s+/).filter(Boolean).length;
            if (wordCount <= WORD_LIMIT) return;
            wrapper.setAttribute("data-collapsed", "true");
            toggleBtn.hidden = false;
            toggleBtn.addEventListener("click", function() {
                var isCollapsed = wrapper.getAttribute("data-collapsed") === "true";
                wrapper.setAttribute("data-collapsed", String(!isCollapsed));
                toggleBtn.setAttribute("aria-expanded", String(isCollapsed));
                setToggleText(toggleBtn, isCollapsed);
            });
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initHomeSeoExpand);
    } else {
        initHomeSeoExpand();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-pain-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function panelOf(item) {
      return item.querySelector('.lp-accordion__panel');
    }

    function openItem(item) {
      item.setAttribute('open', '');
      var panel = panelOf(item);
      if (REDUCE || !panel || !panel.animate) {
        return;
      }
      var end = panel.scrollHeight;
      panel.animate([{ height: '0px' }, { height: end + 'px' }], { duration: 300, easing: 'ease' });
    }

    function closeItem(item) {
      if (!item.hasAttribute('open')) {
        return;
      }
      var panel = panelOf(item);
      if (REDUCE || !panel || !panel.animate) {
        item.removeAttribute('open');
        return;
      }
      var start = panel.scrollHeight;
      var anim = panel.animate([{ height: start + 'px' }, { height: '0px' }], { duration: 300, easing: 'ease' });
      anim.onfinish = function () {
        item.removeAttribute('open');
      };
    }

    function initAccordion(root) {
      if (root.dataset.lpAccordionReady) {
        return;
      }
      root.dataset.lpAccordionReady = 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('.lp-accordion__item'));

      items.forEach(function (item) {
        var summary = item.querySelector('.lp-accordion__summary');
        if (!summary) {
          return;
        }
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          var isOpen = item.hasAttribute('open');
          items.forEach(function (other) {
            if (other !== item) {
              closeItem(other);
            }
          });
          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.lp-accordion').forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp2-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v) {
      return Math.min(96, Math.max(4, v));
    }

    function setPos(frame, handle, pos) {
      var p = clamp(pos);
      frame.style.setProperty('--lp2-pos', p + '%');
      handle.setAttribute('aria-valuenow', Math.round(p));
    }

    function currentPos(frame) {
      return parseFloat(frame.style.getPropertyValue('--lp2-pos')) || 50;
    }

    function init(frame) {
      if (frame.dataset.lp2BaReady) {
        return;
      }
      frame.dataset.lp2BaReady = 'true';
      var handle = frame.querySelector('.lp2-ba__handle');
      if (!handle) {
        return;
      }
      var dragging = false;

      function posFromEvent(event) {
        var rect = frame.getBoundingClientRect();
        return ((event.clientX - rect.left) / rect.width) * 100;
      }

      handle.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        dragging = true;
        try {
          handle.setPointerCapture(event.pointerId);
        } catch (err) {}
      });

      handle.addEventListener('pointermove', function (event) {
        if (!dragging) {
          return;
        }
        setPos(frame, handle, posFromEvent(event));
      });

      function endDrag(event) {
        dragging = false;
        try {
          handle.releasePointerCapture(event.pointerId);
        } catch (err) {}
      }

      handle.addEventListener('pointerup', endDrag);
      handle.addEventListener('pointercancel', endDrag);

      frame.addEventListener('pointerdown', function (event) {
        if (event.target === handle || handle.contains(event.target)) {
          return;
        }
        setPos(frame, handle, posFromEvent(event));
      });

      handle.addEventListener('keydown', function (event) {
        var step = event.shiftKey ? 10 : 2;
        var pos = currentPos(frame);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          setPos(frame, handle, pos - step);
          event.preventDefault();
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          setPos(frame, handle, pos + step);
          event.preventDefault();
        } else if (event.key === 'Home') {
          setPos(frame, handle, 4);
          event.preventDefault();
        } else if (event.key === 'End') {
          setPos(frame, handle, 96);
          event.preventDefault();
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.lp2-ba__frame').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector(".hidden-product__slider");
    if (!slider) return;
    const scrollContainer = slider.querySelector(".hidden-product__cards");
    const leftArrow = slider.querySelector(".hidden-product__scroll-arrow--left");
    const rightArrow = slider.querySelector(".hidden-product__scroll-arrow--right");
    const leftFade = slider.querySelector(".hidden-product__fade--left");
    const rightFade = slider.querySelector(".hidden-product__fade--right");
    if (!scrollContainer || !leftArrow || !rightArrow) return;
    const scrollAmount = 280;
    function updateArrowsAndFades() {
        const scrollLeft = scrollContainer.scrollLeft;
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        leftArrow.disabled = scrollLeft <= 0;
        rightArrow.disabled = scrollLeft >= maxScroll - 1;
        if (leftFade) {
            leftFade.style.opacity = scrollLeft > 0 ? "1" : "0";
        }
        if (rightFade) {
            rightFade.style.opacity = scrollLeft < maxScroll - 1 ? "1" : "0";
        }
    }
    leftArrow.addEventListener("click", function() {
        scrollContainer.scrollBy({
            left: -scrollAmount,
            behavior: "smooth"
        });
    });
    rightArrow.addEventListener("click", function() {
        scrollContainer.scrollBy({
            left: scrollAmount,
            behavior: "smooth"
        });
    });
    scrollContainer.addEventListener("scroll", updateArrowsAndFades);
    updateArrowsAndFades();
    window.addEventListener("resize", updateArrowsAndFades);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-order-page"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const urlParams = new URLSearchParams(window.location.search);
    const isFromCheckout = urlParams.get("from") === "checkout";
    const checkoutTitle = document.querySelector("[data-title-checkout]");
    const infoTitle = document.querySelector("[data-title-info]");
    if (isFromCheckout && checkoutTitle && infoTitle) {
        checkoutTitle.style.display = "block";
        infoTitle.style.display = "none";
        history.replaceState({}, "", window.location.pathname);
    }
    const tabs = document.querySelectorAll(".post-order__tab");
    const panels = document.querySelectorAll(".post-order__panel");
    if (tabs.length === 0 || panels.length === 0) return;
    function switchTab(newTab) {
        const targetId = newTab.getAttribute("aria-controls");
        const targetPanel = document.getElementById(targetId);
        tabs.forEach(function(tab) {
            tab.classList.remove("post-order__tab--active");
            tab.setAttribute("aria-selected", "false");
            tab.setAttribute("tabindex", "-1");
        });
        panels.forEach(function(panel) {
            panel.classList.remove("post-order__panel--active");
            panel.setAttribute("hidden", "");
        });
        newTab.classList.add("post-order__tab--active");
        newTab.setAttribute("aria-selected", "true");
        newTab.setAttribute("tabindex", "0");
        newTab.focus();
        if (targetPanel) {
            targetPanel.classList.add("post-order__panel--active");
            targetPanel.removeAttribute("hidden");
        }
    }
    tabs.forEach(function(tab) {
        tab.addEventListener("click", function() {
            switchTab(this);
        });
        tab.addEventListener("keydown", function(e) {
            var tabsArray = Array.from(tabs);
            var currentIndex = tabsArray.indexOf(this);
            var newIndex;
            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                e.preventDefault();
                newIndex = (currentIndex + 1) % tabsArray.length;
                switchTab(tabsArray[newIndex]);
            } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                e.preventDefault();
                newIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
                switchTab(tabsArray[newIndex]);
            } else if (e.key === "Home") {
                e.preventDefault();
                switchTab(tabsArray[0]);
            } else if (e.key === "End") {
                e.preventDefault();
                switchTab(tabsArray[tabsArray.length - 1]);
            }
        });
    });
});
  } catch(e) { console.error(e); }
})();
})();
